









































































































































































































































































































































































































































































































































































































































































































































import { Component, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { SwTextfield, SwExpandableTextfield } from '@libs-uuif/shared/sw-textfield';
import { SwScrollView } from '@libs-uuif/shared/sw-scroll-view';
import { CreateUserGroup, UserGroupExtension, CreateUser, CreateCustomer } from '@/shared/user-group';
import { SwModal, SwModalBody } from '@libs-uuif/shared/sw-modal';
import { SwButton } from '@libs-uuif/shared/sw-button';
import { State, Mutation } from 'vuex-class';
import { VuexMappedMutation } from '@libs-uuif/shared/common-types';
import { CoreStoreState, SetHelpContainerSlideVisiblePayload, SetHelpContentIdPayload, InfoState } from '@/core/core.store';
import { RootStoreState } from '@/store';
import  { MswApiService } from '@/shared/msw-api-service';
import { tooltip, TooltipDirValues } from '@libs-uuif/shared/tooltip-dir';
import { ApiError } from '@sonicwall/unified-ui-framework/src/shared/api-service';
// import MSW_API_UTILS from '@/shared/msw-api-service/api-utils';
import { SwMessageContainer }  from '@libs-uuif/shared/message-service';
import { helpContentData } from '@/shared/help-content-data/msw-help-data.ts';
import { UserGroupStoreState } from '@/modules/msw-products/components/msw-user-group/store';
import { confirmService, ConfirmOptions, ConfirmButton } from '@libs-uuif/shared/confirm-service';
import idb, { PRODUCTS_STORE_NAME, USERGROUP_STORE_NAME } from '@/services/indexedDb.service';
import TenantDetail from '../tenant-detail.vue';
import { DropdownLight } from '../../../../shared/dropdown-light';
import { SelectOption } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import TenantEdit from './tenant-edit.vue';
import { SwSpinningProgress } from '@sonicwall/unified-ui-framework/src/shared/sw-progress';
import { SwIconButton } from '@libs-uuif/shared/sw-icon-button';
import TenantTransfer from './tenant-transfer.vue';
import localForageService from '@/services/localForageUpdate.service';
import { CreateElement, VNode } from 'vue';
import { currentUserKey } from '@/shared/msw-constants';

const cssPrefix = 'create-new-customer';

@Component({
  components: {
    CreateUserGroup,
    CreateUser,
    CreateCustomer,
    SwButton,
    SwIcon,
    SwScrollView,
    SwMessageContainer,
    SwModal,
    SwModalBody,
    SwTextfield,
    SwExpandableTextfield,
    TenantDetail,
    UserGroupExtension,
    DropdownLight,
    SwSpinningProgress,
    TenantEdit,
    TenantTransfer,
    SwIconButton,
  }, directives: {
    tooltip,
  },
})
export default class MswCreateCustomer extends SwExtendedVue {
  cssPrefix =  cssPrefix;
  enterNewCustomer: boolean = false;
  newCustomerCount: number = 0;
  newCustomer: string = '';
  customerList: any = [];
  selectedCustomer: any = [];
  hoveredCustomer: any = [];
  userGroupCount: number = 0;
  newUserGroupResponse: any = [];
  selectedPartyId: any = [];
  selectedUser: any = [];
  showExtension: boolean = false;
  createUserModal: boolean = false;
  showTenantTransfer: boolean = false;
  createCustomerModal: boolean = false;
  customersListResponse: any = [];
  usersListResponse: any = [];
  usersListResponseCopy: any = [];
  selectedExtensionTab: string = 'user-groups-users-tab';
  newSelectedGroup: any = [];
  defaultUserGroup: any = [];
  addUsersId: string = '';
  showTransferTenant: boolean = false;
  ttDataObj: any = {};
  customerListId: any = 0;
  newlyCreatedTenantName: string = '';
  title: any = '';
  width: any = '392px';
  inviteUserPopup: boolean = false;
  enbleUserInvite: boolean = false;
  updateCountFlag : boolean = false;
  userGroupDataToBeDeleted: any = {
    bsendMail: false,
    userGroupList: [],
  };
  makeDefaultGroup: any = {
    GroupId: '',
    Mode: 'USER',
  };
  usersTobeDeleted: any = {
    bsendMail: false,
    contactLists: [],
  };
  usersTobeAdded:any = {
    bsendMail: false,
    contactLists: [],
  };
  selectedUserGroupId: any = {
    isSelected: false,
    id: 0,
    partyGroupid: '',
  };
  changePermissions: any = [];
  editUserGrouptoBeSent: any = [];
  usersToBeInvited: any = [];
  disableDone: boolean = true;
  productGroupList: any = [];
  tooltipText: string = '';
  enableNewCustomerToolTip: boolean = false;
  newCustomerToolTipContent: string = '';
  clearNameField: boolean = false;
  invitedUsersList: any = [];
  routeToDashbord: boolean = false;
  helplink:string = '';
  defaultGroupId: string = '';
  enableNewCustomer: boolean = false;
  enableHelpContainer: boolean = true;
  makeDefaultFlag: boolean = false;
  editFlag: boolean = false;
  renameCreateCustomer: string = '';
  enableCreateCustomerTooltip: boolean = false;
  createCustomerTooltipContent: string = '';
  cancelFlag: boolean = false;
  newGroupAddedFlag : boolean = false;
  upFixClass : boolean = false;
  downFixClass : boolean = false;
  publicClickEvent : any;
  selectedDiv : any;
  selectedCustomerResponse: any = [];
  showTenantDetail : boolean = false;
  value: string = 'Edit';
  editOrDeleteOrRename : SelectOption[] = [];
  showEditDropDown : boolean = false;
  selectedIndex : any;
  tenantDetailResponse : any ;
  showTenantInfo : any = 'FALSE';
  mode : any = '1';
  startTenantIndex = 0;
  endTenantIndex = 0;
  options: ConfirmOptions;
  buttons: ConfirmButton[];
  showLoader : boolean = false;
  showTopLoader : boolean = false;
  tempCustomerListVariable : any;
  selectedProductGroup :any = null;
  selectedProductGroupIndex :any = -1;
  addUserGroup: boolean = false;
  defaultCustomer: any = {};
  callUpdatePermission : boolean = false;
  calUpdateUserCount : boolean = false;
  userGroupIdUpdate :string = '';
  showMsspButtons : boolean = false;
  showLoading : boolean = false;
  selectedTenantIdForMSSP = '';
  searchedValue = '';
  isExpandSearchFilter: boolean = false;
  showInitialLoader : boolean = false;
  apiCalledBeforeLoading : boolean = false;
  customerCreatedBeforeApiCall : any[] = [];
  noEarlySpinner = true;
  loadCustomerWithoutApiFlag :boolean = false;
  forceFetch :boolean = false;
  awaitingSearch : boolean = false;
  setTimeoutId : any = null;
  backedUpProductGroup = [];
  searchIsActive : boolean = false;
  tempLoadLastIndex = 100;
  newGroupAddedFlagSmallCustomer : boolean = false;
  newUserGroup : string = '';
  isHardRefresh : boolean = false;
  selectedPartyGroupId : any = '';
  @Mutation
  setHelpContentId: VuexMappedMutation<SetHelpContentIdPayload>;

  @Mutation
  readonly setHelpContainerSlideVisible: VuexMappedMutation<SetHelpContainerSlideVisiblePayload>;

  @State((state: RootStoreState) => state.CoreStoreModule.helpContainerSlideVisible)
  helpContainerSlideVisible: CoreStoreState['helpContainerSlideVisible'];

  @State((state: RootStoreState) => state.MswUserGroupStoreModule.selectedUserGroup)
  selectedUserGroup: UserGroupStoreState['selectedUserGroup'];

  @Watch('selectedUser')
  selectedUserChange() {
    if (!this.selectedUser || this.selectedUser.length === 0 || !this.selectedUser[0]) { return; }
    this.$store.commit('MswUserGroupStoreModule/mutate', { property: 'addUserFlag', with:  this.selectedUser[0].isReadOnlyAccess !== 'YES' });
  }

  addUser: boolean = false;
  submitNewCustomer() {
    if (this.newCustomer.trim() !== '') {
      if (this.newCustomer.length < 51) {
        if (this.checkForCustomerList(this.newCustomer)) {
          this.enableNewCustomerToolTip = false;
          const createProductGroupRequest = {
            productGroup: this.newCustomer,
            partyGroupId: this.defaultGroupId,
            userGrpName: this.productGroupList.partyGroupName,
            source: 'WORKSPACE',
          };
          this.$store.commit('startLoading');
          this.apiCalledBeforeLoading = this.showInitialLoader ? true : false;
          MswApiService.createCustomer.postNewCustomer(createProductGroupRequest)
          .then((resp: any) => {
            if (resp.msgCode === 'MSWAPP:CREATPRODUCTGROUPSUCCESS') {
              const message: InfoState = { infoType: 'success', infoMsg: '1 tenant added successfully' };
              this.$store.commit('displayMessage', message);
              if (this.apiCalledBeforeLoading && this.showInitialLoader) {
                this.enterNewCustomer = false;
                this.apiCalledBeforeLoading = false;
                this.customerCreatedBeforeApiCall.push(this.createAndStoreCustomerObjects(resp.productGroupDetail));
                this.customerList = [];
                this.customerList.push(this.customerCreatedBeforeApiCall[this.customerCreatedBeforeApiCall.length - 1]);
                this.selectedCustomer.push(this.newCustomer);
                this.newCustomer = '';
              } else if (this.apiCalledBeforeLoading && !this.showInitialLoader) {
                this.apiCalledBeforeLoading = false;
                this.customerCreatedBeforeApiCall.push(this.createAndStoreCustomerObjects(resp.productGroupDetail));
                this.customerCreatedBeforeApiCall.forEach((ele : any) => {
                  const findIndex = this.tempCustomerListVariable.findIndex((obj: any) => obj.productGroupId === ele.productGroupId);
                  if (findIndex === -1) {
                    this.tempCustomerListVariable.splice(1, 0 , ele);
                  }
                });
                this.getSlicedCustomer();
              } else {
                this.startTenantIndex = 0;
                this.endTenantIndex = 0;
                if (this.$store.getters.isLargeCustomer) {
                  this.$store.dispatch('DashBoardStoreModule/populateCustomerWidgets')
                  .then((response: any) => {
                    this.addCustomerForLargeCustomer(response, resp.productGroupDetail);
                  });
                } else {
                  this.newlyCreatedTenantName = this.newCustomer;
                  this.loadCustomerList();
                }
                this.selectedCustomer.push(this.newCustomer);
                this.divClicked(true);
                this.newCustomerCount = this.productGroupList.length;
              // this.newCustomer = '';
                this.enterNewCustomer = false;
                this.$store.commit('DashBoardStoreModule/updateWidgetInfo', []);
                this.changehelpContent('customer-user-groups-help');
              }
            } else if (resp.msgCode === 'MSWAPP:ADDRESSCOLLECTIONNEEDED') {
              this.tenantDetailResponse = {
                request : createProductGroupRequest,
                response : resp,
              };
              this.mode = 'created';
              this.showTenantDetail = true;
            } else {
              const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc || (this.$t('userGroups.unknowErr')
              .toString()) };
              this.$store.commit('displayMessage', message);
            }
          })
          .catch((error: any) => {
            const message: InfoState = { infoType: 'high', infoMsg: (error && error.message) || (this.$t('userGroups.unknowErr').toString()) };
            this.$store.commit('displayMessage', message);
          })
          .finally(() => {
            this.$store.commit('stopLoading');
          });
        } else {
          this.enableNewCustomerToolTip = true;
          this.newCustomerToolTipContent = (this.$t('userGroups.tenantNameExist')
          .toString());
        }
      } else {
        this.enableNewCustomerToolTip = true;
      }
    } else {
      this.enableNewCustomerToolTip = true;
      this.newCustomerToolTipContent = (this.$t('userGroups.enterTenantName')
      .toString());
    }
    if (this.customerList.length > 0) {
      this.disableDone = false;
    }
  }

  addCustomerForLargeCustomer(response : any, productGroupDetail : any) {
    // tslint:disable-next-line:prefer-const
    let newResponse = response;
    newResponse.prodGroupLicenseStatus.splice(1, 0, productGroupDetail);
    this.tempCustomerListVariable.splice(1, 0, this.createAndStoreCustomerObjects(productGroupDetail));
    this.productGroupList.splice(1, 0, this.createAndStoreCustomerObjects(productGroupDetail));
    this.backedUpProductGroup = this.productGroupList;
    this.customerList.splice(1, 0, this.createAndStoreCustomerObjects(productGroupDetail));
    this.$set(this.customerList , 0 , this.customerList[0]);
    this.saveForageData(newResponse, this.customerList[1].productGroupId);
    if (this.tempCustomerListVariable.length > 100) {
      if (this.endTenantIndex === 0) {
        this.endTenantIndex = 100;
      }
    } else {
      this.startTenantIndex = 0;
      this.endTenantIndex = this.tempCustomerListVariable.length;
    }
    this.newCustomerCount = this.productGroupList.length;
    this.getSlicedCustomer();
    this.$store.commit('stopLoading');
  }

  createAndStoreCustomerObjects(ele : any) {
    const prartyGroupNameList: any = ele.hasOwnProperty('partyGroupName') ? ele.partyGroupName.split('^& ') : [];
    const availableUserGroupForProductGroup: any = [];
    const assignedUserGroupForProductGroup: any = [];
    this.newUserGroupResponse.map((id: any) => {
          // console.log(prartyGroupNameList.find((item: any) => item === id.partyGroupName));
      if (prartyGroupNameList.includes(id.partyGroupName)) {
        assignedUserGroupForProductGroup.push(id);
      } else {
        availableUserGroupForProductGroup.push(id);
      }
    });
        // console.warn(availableUserGroupForProductGroup);
    const returnObj = {
      productGroupId: ele.hasOwnProperty('productGroupId') ? ele.productGroupId : '',
      productGroupName: ele.hasOwnProperty('productGroupName') ? ele.productGroupName : '',
      status: ele.hasOwnProperty('status') ? ele.status : '',
      totalProducts: ele.hasOwnProperty('totalProducts') ? ele.totalProducts : '',
      isDefaultGroup: ele.hasOwnProperty('isDefaultGroup') ? ele.isDefaultGroup : '',
          // isOwnDefaultGroup: ele.hasOwnProperty('isOwnDefaultGroup') ? ele.isOwnDefaultGroup : '',
      sharedGroup: ele.hasOwnProperty('sharedGroup') ? ele.sharedGroup : ele.hasOwnProperty('isSharedProductGroup') ? ele.isSharedProductGroup : '',
          // sharedGroupBool: ele.hasOwnProperty('sharedGroupBool') ? ele.sharedGroupBool : '',
          // mgeUserGroupLink: ele.hasOwnProperty('mgeUserGroupLink') ? ele.mgeUserGroupLink : '',
          // mgeProductLink: ele.hasOwnProperty('mgeProductLink') ? ele.mgeProductLink : '',
      deleteLink: ele.hasOwnProperty('deleteLink') ? ele.deleteLink : ele.hasOwnProperty('showDeleteLink') ? ele.showDeleteLink : '',
          // mgeUserGrpPagelink: ele.hasOwnProperty('mgeUserGrpPagelink') ? ele.mgeUserGrpPagelink : '',
      setDefaultGroupLink: ele.hasOwnProperty('setDefaultGroupLink') ? ele.setDefaultGroupLink : ele.hasOwnProperty('showDefault') ? ele.showDefault : '',
      renameLink: ele.hasOwnProperty('renameLink') ? ele.renameLink : ele.hasOwnProperty('showRenameLink') ? ele.showRenameLink : '',
          // isStarred: ele.hasOwnProperty('isStarred') ? ele.isStarred : false,
      lastAccessDate: ele.hasOwnProperty('lastAccessDate') ? ele.lastAccessDate : '',
          // dtLastAccessDate: ele.hasOwnProperty('dtLastAccessDate') ? ele.dtLastAccessDate : '',
      lastAccessTime: ele.hasOwnProperty('lastAccessTime') ? ele.lastAccessTime : '',
      selectedGroup: assignedUserGroupForProductGroup,
      isReadOnlyAccess: ele.hasOwnProperty('isReadOnlyAccess') ? ele.isReadOnlyAccess : '',
      userGroupResponse: availableUserGroupForProductGroup,
      showTenantInfo : this.showTenantInfo,
      sharedGroupHoverText: ele.hasOwnProperty('sharedGroupHoverText') ? ele.sharedGroupHoverText : '',
    };
    return returnObj;
  }

  get newCustomerIdTooltipValue() : TooltipDirValues  {
    return {
      enabled: this.enableNewCustomerToolTip,
      placement: 'top',
      persistent: true,
      compact: true,
      content: this.newCustomerToolTipContent,
    };
  }

  get getAvailableUsergroups() {
    if (this.customerListId >= 0 && this.customerList[this.customerListId]) {
      if (this.customerList[this.customerListId].userGroupResponse) {
        return this.customerList[this.customerListId].userGroupResponse;
      }
    }
    return [];
  }

  get getSelectedGroupList() {
    if (this.customerListId >= 0 && this.customerList[this.customerListId]) {
      if (this.customerList[this.customerListId].selectedGroup) {
        return this.customerList[this.customerListId].selectedGroup;
      }
    }
    return [];
  }

  changehelpContent(flagname:string) {
    helpContentData.forEach((node) => {
      if (node.helpId === flagname) {
        this.helplink = node.content;
      }
    });
  }
  onNewCustomerInput(value: string) {
    this.enableNewCustomerToolTip = false;
    if (value.trim() !== '') {
      if (value.length > 50) {
        this.enableNewCustomerToolTip = true;
        this.newCustomerToolTipContent = (this.$t('userGroups.charExceed')
        .toString());
        return;
      }
    }
    this.newCustomer = value;
  }
  checkForCustomerList(name: string) {
    const matchedName = this.productGroupList.find((ele: any) => ele.productGroupName.toLowerCase() === name.toLowerCase()) ||
                                              this.customerList.find((ele: any) => ele.productGroupName.toLowerCase() === name.toLowerCase()) || '';
    return (matchedName === '') ? true : false;
  }
  createNewCustomer() {
    this.newCustomer = '';
    this.enterNewCustomer = !this.enterNewCustomer;
    if (this.enterNewCustomer) {
      this.handleSearchFilter('');
      this.isExpandSearchFilter = false;
    }
    this.enterNewCustomer ? this.focusCreateCustomerTextbox() : '';
    // this.selectedCustomer = [];
    this.upFixClass = false;
    // this.hoveredCustomer = [];
  }

  cancelNewCustomer() {
    this.newCustomer = '';
    this.enterNewCustomer = false;
    // this.selectedCustomer = [];
    // this.hoveredCustomer = [];
  }

  selectedCustomerName(name: string) {
    // console.warn(this.selectedCustomer);
    this.customerListId = this.customerList.findIndex((ele: any) => ele.productGroupName === this.selectedCustomer[0]);
    return this.selectedCustomer[0] === name;
  }

  hoveredCustomerName(name: string) {
    // this.customerListId = this.customerList.findIndex((ele: any) => ele.productGroupName === this.selectedCustomer[0]);
    return this.hoveredCustomer[0] === name ;
  }

  selectCustomer(name: string) {
    // console.warn(this.hoveredCustomer);
    // console.warn(this.customerListId);
    if (!this.editFlag  && !this.cancelFlag) {
      this.showExtension = false;
      window.parent.postMessage({
        showHelp : this.showExtension,
      },                        '*');
      if (this.hoveredCustomer.length > 0) {
        this.hoveredCustomer = [];
        this.setSelectCustomer(name);
      } else {
        this.setSelectCustomer(name);
      }
    } else {
      this.cancelFlag = false;
    }
  }

  setSelectCustomer(name: string) {
    // console.warn(this.selectedCustomer);
    // console.warn(name);
    if (this.selectedCustomer[0] === name) {
      this.selectedCustomer = [];
    } else {
      if (this.selectedCustomer.length > 0) {
        this.selectedCustomer = [];
      }
      this.selectedCustomer.push(name);
      if (this.$store.getters.isLargeCustomer) {
        this.reloadCustomer(name);
        this.$store.dispatch('MswUserGroupStoreModule/userGroupSelected', []);
        // this.selectedUser = [];
        this.showExtension = false;
      } else {
        this.fetchUserGroupsForSelectedTenant(name);
      }
    }
    const flagname = this.selectedCustomer[0] === name ? 'customer-user-groups-help2' : 'create-customers';
    helpContentData.forEach((node) => {
      if (node.helpId === flagname) {
        this.helplink = node.content;
      }
    });
  }

  fetchUserGroupsForSelectedTenant(name: string) {
    const customerIndex = this.customerList.findIndex((ele: any) => ele.productGroupName === name);
    if (customerIndex < 0) {
      return;
    }
    const customer = this.customerList[customerIndex];
    if (!customer.productGroupId) {
      return;
    }
    this.$store.commit('startLoading');
    this.fetchAndSetUserGroupsForCustomer(customer.productGroupId, customerIndex)
      .catch((error: any) => {
        const message: InfoState = { infoType: 'high', infoMsg: (error && error.message) || (this.$t('userGroups.unknowErr').toString()) };
        this.$store.commit('displayMessage', message);
      })
      .finally(() => {
        this.$store.commit('stopLoading');
      });
  }
  reloadCustomer(name : any) {
    const customerListIndex = this.customerList.findIndex((ele : any) => ele.productGroupName === name);
    if (customerListIndex > -1) {
      const obj = this.createAndStoreCustomerObjects(this.customerList[customerListIndex]);
      this.$set(this.customerList, customerListIndex, obj);
    }
  }

  mapUserGroupFromApi(g: any) {
    return {
      partyGroupId: g.partyGroupId,
      partyGroupName: g.partyGroupName,
      isDefaultGroup: g.isDefaultGroup && g.isDefaultGroup.trim().toUpperCase() === 'YES' ? 'TRUE' : 'FALSE',
      orgId: g.orgId,
      renameLink: g.renameLink,
      deleteLink: g.deleteLink,
      setAsDefaultGroup: g.SetDefaultLink,
      totalContacts: g.totalContacts,
      isAffilated: g.isAffiliated,
      isAutoAffiliated: g.isAutoAffiliated,
      isReadOnlyAccess: g.isReadOnlyAccess || 'NO',
      mgeProdGrpPagelink: g.mgeProdGrpPagelink ? g.mgeProdGrpPagelink.toString().toUpperCase() : 'FALSE',
      usersForUserGroup: Array.isArray(g.usersForUserGroup) ? g.usersForUserGroup : [],
    };
  }

  fetchAndSetUserGroupsForCustomer(tenantId: string, customerIndex: number): Promise<void> {
    return MswApiService.createCustomer.getUserGroupsForTenant(tenantId)
      .then((resp: any) => {
        const content = resp && resp.content ? resp.content : {};
        const available = Array.isArray(content.availbleUserGroup) ? content.availbleUserGroup.map((g: any) => this.mapUserGroupFromApi(g)) : [];
        const assigned = Array.isArray(content.assignedUserGroup) ? content.assignedUserGroup.map((g: any) => this.mapUserGroupFromApi(g)) : [];
        if (content.showCreateUserGrplink) {
          this.addUserGroup = content.showCreateUserGrplink.toLowerCase() === 'yes';
        }
        this.userGroupCount = available.length + assigned.length;
        if (customerIndex >= 0 && this.customerList[customerIndex]) {
          this.$set(this.customerList[customerIndex], 'userGroupResponse', available);
          this.$set(this.customerList[customerIndex], 'selectedGroup', assigned);
        }
      });
  }

  updateSelectedProductGroup() {
    if (this.selectedCustomer.length > 0) {
      const indexInMainCustomerList = this.tempCustomerListVariable.findIndex((ele: any) => ele.productGroupName === this.selectedCustomer[0]);
      this.selectedProductGroup = this.tempCustomerListVariable[indexInMainCustomerList];
    } else {
      this.selectedProductGroup = null;
    }
  }

  rebuildTempCustomerList() {
    this.tempCustomerListVariable = [];
    if (this.productGroupList.length < 100) {
      this.productGroupList.forEach((ele: any) => {
        this.tempCustomerListVariable.push(this.createAndStoreCustomerObjects(ele));
      });
    } else {
      this.tempLoadLastIndex = 100;
      for (let i = 0; i < this.tempLoadLastIndex; i += 1) {
        this.tempCustomerListVariable.push(this.createAndStoreCustomerObjects(this.productGroupList[i]));
      }
    }
  }

  hoverCustomer(name: string) {
    if (!this.editFlag) {
      if (this.selectedCustomer.length > 0) {
        this.hoveredCustomer = [];
      } else {
        this.hoveredCustomer = [name];
      }
    }
  }
  unHoverCustomer() {
    if (!this.editFlag) {
      this.hoveredCustomer = [];
    }
  }
  created() {
    if (this.$router.currentRoute.query.hasOwnProperty('redirect')) {
      if (this.$router.currentRoute.query.redirect === 'true') {
        this.routeToDashbord = true;
        this.enterNewCustomer = true;
      } else {
        this.routeToDashbord = false;
        this.enterNewCustomer = false;
      }
    } else {
      this.routeToDashbord = false;
    }
    this.loadDefaultGroup();
    // this.setHelpContentId({ helpId: 'create-customers' });
    this.setHelpId('create-customers');
  }
  setHelpId(value:string) {
    const temp:string[] = [];
    temp.push(value);
    this.setHelpContentId({ helpId:temp });
  }
  mounted() {
    // this.setHelpContentId({ helpId: 'create-customers' });
    this.setHelpId('create-customers');
    helpContentData.forEach((node) => {
      if (node.helpId === 'create-customers') {
        this.helplink = node.content;
      }
    });
  }
  onScrollView(e : Event) {
    this.resetView(e);
  }
  resetView(e ? : Event) {
    if (e) {
      const myScroll = this.$refs.vscroll as HTMLElement;
      // console.warn(this.customerList.findIndex((ele: any) => ele.productGroupName === this.selectedCustomer[0]));
      if (((myScroll.scrollTop + document.getElementById('scrollNav')!.getBoundingClientRect().height) - myScroll.scrollHeight > -25) &&
      (myScroll.scrollTop + document.getElementById('scrollNav')!.getBoundingClientRect().height) - myScroll.scrollHeight < 25) {
        if (this.productGroupList.length - this.endTenantIndex >= 30 && !this.showLoader) {
          const myScroll1 = myScroll as unknown as SwScrollView;
          this.showLoader = true;
          setTimeout(() => {
            this.updateSelectedProductGroup();
            this.endTenantIndex = this.endTenantIndex + 30;
            this.startTenantIndex = this.startTenantIndex + 30;
            this.loadMoreCustomers(this.endTenantIndex);
            this.getSlicedCustomer();
            myScroll1.updatePosition((myScroll as any).scrollTop - (45 * 30), true);
            this.showLoader = false;
          },         1000);
        // tslint:disable-next-line:max-line-length
        } else if ((this.productGroupList.length - this.endTenantIndex < 30 && this.productGroupList.length - this.endTenantIndex > 0) && !this.showLoader) {
          const myScroll1 = myScroll as unknown as SwScrollView;
          this.showLoader = true;
          setTimeout(() => {
            this.updateSelectedProductGroup();
            const endIndexOffset = this.productGroupList.length - this.endTenantIndex;
            this.endTenantIndex = this.endTenantIndex + endIndexOffset;
            this.startTenantIndex = this.startTenantIndex + endIndexOffset;
            this.loadMoreCustomers(this.endTenantIndex);
            this.getSlicedCustomer();
            myScroll1.updatePosition((myScroll as any).scrollTop - (45 * endIndexOffset), true);
            this.showLoader = false;
          },         1000);
        }
      } else if (myScroll.scrollTop === 0) {
        if (this.startTenantIndex >= 30 && !this.showTopLoader) {
          const myScroll1 = myScroll as unknown as SwScrollView;
          this.showTopLoader = true;
          setTimeout(() => {
            this.updateSelectedProductGroup();
            this.endTenantIndex = this.endTenantIndex - 30;
            this.startTenantIndex = this.startTenantIndex - 30;
            this.getSlicedCustomer();
            myScroll1.updatePosition((myScroll as any).scrollTop + (45 * 30), true);
            this.showTopLoader = false;
          },         1000);
        } else if ((this.startTenantIndex < 30 && this.startTenantIndex > 0) && !this.showTopLoader) {
          const myScroll1 = myScroll as unknown as SwScrollView;
          this.showTopLoader = true;
          setTimeout(() => {
            this.updateSelectedProductGroup();
            const startIndex = this.startTenantIndex;
            this.endTenantIndex = this.endTenantIndex - this.startTenantIndex;
            this.startTenantIndex = 0;
            this.getSlicedCustomer();
            myScroll1.updatePosition((myScroll as any).scrollTop + (45 * startIndex), true);
            this.showTopLoader = false;
          },         1000);
        }
      }
      if (this.publicClickEvent && document.getElementById('selectedRow')) {
        this.selectedDiv = document.getElementById('selectedRow')!.getBoundingClientRect();
        const container = document.getElementById('scrollNav')!.getBoundingClientRect();
        let ind = this.customerList.findIndex((ele: any) => ele.productGroupName === this.selectedCustomer[0]);
        // calculating index afetr introducing slicing
        if (ind > 100) {
          ind = ind - this.startTenantIndex;
        }
        let nextEle : any;
        let prevEle : any;
        // tslint:disable-next-line:prefer-template
        if (document.getElementById('unSelected' + (ind + 1))) {
        // tslint:disable-next-line:prefer-template
          nextEle = document.getElementById('unSelected' + (ind + 1))!.getBoundingClientRect();
        } else {
          // tslint:disable-next-line:prefer-template
          prevEle = document.getElementById('unSelected' + (ind - 1))!.getBoundingClientRect();
        }
        if (container.top >= this.selectedDiv.top) {
          if (ind === 0) {
            this.upFixClass = this.upFixClass ? container.top <= nextEle.top ? false : true : true;
          } else {
            this.upFixClass = this.upFixClass ? container.top <= nextEle.top - nextEle.height ? false : true : true;
          }
        } else {
          this.upFixClass =  false;
        }
        if (container.bottom <= this.selectedDiv.bottom) {
          if (nextEle) {
            this.downFixClass = container.bottom >= (nextEle.top - 30) ? false : true ;
          } else {
            this.downFixClass = Math.abs(prevEle.bottom - container.bottom) > 55 ? true : false;
          }
        } else {
          this.downFixClass = false;
        }
      } else if (this.showEditDropDown) {
        const dropDownBox = document.getElementsByClassName('dropdown_main__inner')[0]!.getBoundingClientRect();
        const container = document.getElementById('scrollNav')!.getBoundingClientRect();
        if (dropDownBox.top < container.top) {
          this.showEditDropDown = false;
        }
        if (dropDownBox.top > container.bottom) {
          this.showEditDropDown = false;
        }
      }
    }
  }

  get createUserWidth() {
    return this.width;
  }

  get createUserTitle() {
    return this.title;
  }

  changeStyle(changeStyleVal: string) {
    if (changeStyleVal === 'YES') {
      this.width = '58rem';
      this.title = 'Invite User';
      this.inviteUserPopup = true;
    } else {
      this.width = '392px';
      this.title = '';
      this.inviteUserPopup = false;
      this.enbleUserInvite = !this.enbleUserInvite;
    }
  }

  divClicked(event : any) {
    this.selectedProductGroup = null;
    this.selectedProductGroupIndex = -1;
    this.showEditDropDown = false;
    if (this.upFixClass) {
      const myScroll = this.$refs.vscroll as HTMLElement;
      const myScroll1 = this.$refs.vscroll as SwScrollView;
      myScroll1.updatePosition(myScroll.scrollTop + 45, true);
    }
    if (document.getElementById('selectedRow')) {
      this.selectedDiv = document.getElementById('selectedRow')!.getBoundingClientRect();
    }
    this.upFixClass =  false;
    this.downFixClass = false;
    this.publicClickEvent = event;
  }
  focusCreateCustomerTextbox() {
    setTimeout(() => {
      const wrapper2 = document.getElementById('newCustomer') as HTMLElement;
      if (wrapper2) {
        wrapper2.children[0]
          .getElementsByTagName('input')[0]
          .focus();
      }
    },         200);
  }
  groupExtension(partyGroupId: any, flag: boolean) {
    this.selectedPartyId = partyGroupId;
    this.addUsersId = '';
    if (!flag) {
      if (this.customerList[this.customerListId].hasOwnProperty('userGroupResponse')) {
        // tslint:disable-next-line:max-line-length
        const userGrouSelected = this.customerList[this.customerListId].userGroupResponse.filter((data:any) => (data.partyGroupId === this.selectedPartyId));
        if (userGrouSelected.length > 0) {
          userGrouSelected.length > 0 ? this.addUsersId = userGrouSelected[0].partyGroupId : this.addUsersId = '';
          const selectedId = this.customerList[this.customerListId].userGroupResponse.findIndex((data:any) => (data.partyGroupId === this.selectedPartyId));
          this.selectedUserGroupId = {
            id: selectedId,
            isSelected: false,
            partyGroupId: this.customerList[this.customerListId].userGroupResponse[selectedId].partyGroupId,
          };
          const selectedUserCopy =  this.customerList[this.customerListId].userGroupResponse.filter((data:any) => (data.partyGroupId === this.selectedPartyId));
          if (!selectedUserCopy[0].hasOwnProperty('loaded') && this.$store.getters.isLargeCustomer) {
            // tslint:disable-next-line:max-line-length
            this.loadUsersForUserGroupForLargeCustomer(selectedUserCopy[0]);
          } else {
            this.selectedUser =  this.customerList[this.customerListId].userGroupResponse.filter((data:any) => (data.partyGroupId === this.selectedPartyId));
          }
        } else {
          this.addUsersId = '';
        }
      }
    } else {
      if (this.customerList[this.customerListId].hasOwnProperty('selectedGroup')) {
        // tslint:disable-next-line:max-line-length
        const userGrouSelected = this.customerList[this.customerListId].selectedGroup.filter((data:any) => (data.partyGroupId === this.selectedPartyId));
        if (userGrouSelected.length > 0) {
          userGrouSelected.length > 0 ? this.addUsersId = userGrouSelected[0].partyGroupId :  this.addUsersId = '' ;
          const selectedId = this.customerList[this.customerListId].selectedGroup.findIndex((data:any) => (data.partyGroupId === this.selectedPartyId));
          this.selectedUserGroupId = {
            id: selectedId,
            isSelected: true,
            partyGroupId: this.customerList[this.customerListId]?.selectedGroup[selectedId]?.partyGroupId || '',
          };
          const selectedUserCopy =  this.customerList[this.customerListId].selectedGroup.filter((data:any) => (data.partyGroupId === this.selectedPartyId));
          if (!selectedUserCopy[0].hasOwnProperty('loaded') && this.$store.getters.isLargeCustomer) {
            // tslint:disable-next-line:max-line-length
            this.loadUsersForUserGroupForLargeCustomer(selectedUserCopy[0]);
          } else {
            this.selectedUser =  this.customerList[this.customerListId].selectedGroup.filter((data:any) => (data.partyGroupId === this.selectedPartyId));
          }
        } else {
          this.addUsersId = '';
        }
      }
    }
  }

  checkHelpFlag(flagName: string, extendUserGroup: boolean) {
    this.showExtension = extendUserGroup || false;
    window.parent.postMessage({
      showHelp : this.showExtension,
    },                        '*');
    this.selectedExtensionTab = flagName;
    if (flagName === 'user-groups-help') {
      this.selectedExtensionTab = 'user-groups-users-tab';
    }
    switch (flagName) {
      case 'user-groups-help':
        this.enableHelpContainer = true;
        break;
      case 'user-groups-customer-tab':
        this.enableHelpContainer = false;
        break;
      case 'user-groups-users-tab':
        this.enableHelpContainer = false;
        break;
      case 'user-groups-permission-tab':
        this.enableHelpContainer = false;
        break;
      default:
        this.enableHelpContainer = true;
        break;
    }
    helpContentData.forEach((node) => {
      let flagnameRecieved: string = '';
      if (flagName === 'user-groups-help') {
        flagnameRecieved = 'customer-user-groups-help2';
      } else {
        flagnameRecieved = flagName;
      }
      if (node.helpId === flagnameRecieved) {
        this.helplink = node.content;
        this.setHelpId(flagnameRecieved);
      }
    });
  }

  addNewUserGroup(newUserGroup: string, flag: boolean, index: any, selected: boolean) {
    if (flag) {
      // for new user group
      this.$store.commit('startLoading');
      this.newGroupAddedFlagSmallCustomer = false;
      MswApiService.createCustomer.createUserGrp(newUserGroup, this.customerList[this.customerListId].productGroupId)
      .then((resp: any) => {
        if (resp.operationStatus === 'NOK') {
          this.$store.commit('stopLoading');
          // this.loadDefaultGroup();
          const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
          this.$store.commit('displayMessage', message);
        } else {
          this.$store.commit('stopLoading');
          this.fetchUserGroupsForSelectedTenant(this.selectedCustomer[0]);
          const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
          this.$store.commit('displayMessage', message);
        }
      })
      .catch((error: ApiError) => {
        this.$store.commit('stopLoading');
        this.loadDefaultGroup();
        const message: InfoState = { infoType: 'high', infoMsg: error.message || (this.$t('userGroups.unknowErr')
        .toString()) };
        this.$store.commit('displayMessage', message);
      });
    } else {
      let listItemPartyGroupId : any;
      const data = this.$refs.createUserGroup as CreateUserGroup;
      if (selected) {
        data.selectedListItems.forEach((ele : any, i : any) => {
          if (i === index) {
            listItemPartyGroupId = ele.partyGroupId;
          }
        });
      } else {
        data.listItems.forEach((ele : any, i : any) => {
          if (i === index) {
            listItemPartyGroupId = ele.partyGroupId;
          }
        });
      }
      const dataToBeEdited = {
        partyGroupId: listItemPartyGroupId,
        newPartyGroupName: newUserGroup,
        bSendMail: false,
      };
      this.$store.commit('startLoading');
      MswApiService.createCustomer.editUserGroup(dataToBeEdited)
      .then((resp: any) => {
        if (resp.operationStatus === 'NOK') {
          this.$store.dispatch('MswUserGroupStoreModule/userGroupSelected', []);
          this.showExtension = false;
          window.parent.postMessage({
            showHelp : this.showExtension,
          },                        '*');
          const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
          this.$store.commit('displayMessage', message);
          // this.loadDefaultGroup();
        } else {
          if (this.selectedUserGroup.length > 0) {
            this.$store.dispatch('MswUserGroupStoreModule/userGroupSelected', [listItemPartyGroupId]);
          }
          const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
          this.$store.commit('displayMessage', message);
          // this.loadDefaultGroup();
          if (this.$store.getters.isLargeCustomer) {
            MswApiService.createCustomer.getUserGroup()
             .then((response: any) => {
               this.editUserNameForLargeCustomer(response, listItemPartyGroupId, newUserGroup);
             })
             .catch((error: any) => {
               const message: InfoState = { infoType: 'high', infoMsg: (error && error.message) || (this.$t('userGroups.unknowErr').toString()) };
               this.$store.commit('displayMessage', message);
             })
             .finally(() => {
               this.$store.commit('stopLoading');
             });
          } else {
            this.editUserName();
            this.$store.commit('stopLoading');
          }
        }
      })
      .catch((error: any) => {
        this.$store.commit('stopLoading');
        const message: InfoState = { infoType: 'high', infoMsg: (error && error.message) || (this.$t('userGroups.unknowErr').toString()) };
        this.$store.commit('displayMessage', message);
      });
    }
  }

  editUserNameForLargeCustomer(response : any, listItemPartyGroupId : any, newUserGroup: any) {
    const newResponse = response;
    const userGroupIndex = this.newUserGroupResponse.findIndex((ele : any) => ele.partyGroupId === listItemPartyGroupId);
    const lastRemenberedName = this.newUserGroupResponse[userGroupIndex].partyGroupName;
    this.newUserGroupResponse[userGroupIndex].partyGroupName = newUserGroup;
    this.$set(this.newUserGroupResponse , userGroupIndex, this.newUserGroupResponse[userGroupIndex]);
    const ugIndex = newResponse.userGroups.findIndex((ele:any) => ele.partyGroupId === listItemPartyGroupId);
    newResponse.userGroups[ugIndex].partyGroupName = newUserGroup;
    this.saveForageDataForUserGroup(newResponse, listItemPartyGroupId);
    // this.refreshCustomerListTillLoadedWithRename(lastRemenberedName, this.newUserGroupResponse[userGroupIndex].partyGroupName , true);
    this.loadCustomerWithoutApi(lastRemenberedName, this.newUserGroupResponse[userGroupIndex].partyGroupName , true);
    this.$store.dispatch('DashBoardStoreModule/populateCustomerWidgets')
      .then((resp: any) => {
        this.updateCustomerPartyGroupName(resp, newUserGroup, lastRemenberedName, true);
      });
    this.$store.commit('stopLoading');
  }
  editUserName() {
    const tenantId = this.customerList[this.customerListId].productGroupId;
    this.$store.commit('startLoading');
    this.fetchAndSetUserGroupsForCustomer(tenantId, this.customerListId)
    .catch((error: any) => {
      const message: InfoState = { infoType: 'high', infoMsg: (error && error.message) || (this.$t('userGroups.unknowErr').toString()) };
      this.$store.commit('displayMessage', message);
    })
    .finally(() => {
      this.$store.commit('stopLoading');
    });
  }

  deleteUserGroup(index: any, flag: boolean) {
    const data = this.$refs.createUserGroup as CreateUserGroup;
    if (flag) {
      data.selectedListItems.forEach((ele : any, i : any) => {
        if (i === index) {
          this.userGroupDataToBeDeleted.userGroupList.push({
            partyGroupId: ele.partyGroupId,
          });
        }
      });
    } else {
      data.listItems.forEach((ele : any, i : any) => {
        if (i === index) {
          this.userGroupDataToBeDeleted.userGroupList.push({
            partyGroupId: ele.partyGroupId,
          });
        }
      });
    }
    this.deleteUserGroupApi(this.userGroupDataToBeDeleted);
    this.userGroupCount = this.newUserGroupResponse.length;
  }

  deleteUserGroupApi(data: any) {
    this.$store.commit('startLoading');
    MswApiService.createCustomer.deleteUserGroup(data)
    .then((resp: any) => {
      this.userGroupDataToBeDeleted = { bsendMail: false, userGroupList: [] };
      const message: InfoState = { infoType: resp.msgCode === 'MSWAPP:DELTEUSERGROUPSUCCESS' ? 'success' : 'high', infoMsg: resp.msgDesc };
      this.$store.commit('displayMessage', message);
      if (resp.msgCode !== 'MSWAPP:DELTEUSERGROUPSUCCESS') {
        this.$store.commit('stopLoading');
        return;
      }
      const customerIndex = this.customerList.findIndex((ele: any) => ele.productGroupName === this.selectedCustomer[0]);
      const tenantId = customerIndex >= 0 && this.customerList[customerIndex] ? this.customerList[customerIndex].productGroupId : null;
      if (!tenantId) {
        this.$store.commit('stopLoading');
        return;
      }
      this.fetchAndSetUserGroupsForCustomer(tenantId, customerIndex)
      .catch((error: any) => {
        const errMessage: InfoState = { infoType: 'high', infoMsg: (error && error.message) || (this.$t('userGroups.unknowErr').toString()) };
        this.$store.commit('displayMessage', errMessage);
      })
      .finally(() => {
        this.$store.commit('stopLoading');
      });
    })
    .catch((error: any) => {
      this.$store.commit('stopLoading');
      const message: InfoState = { infoType: 'high', infoMsg: (error && error.message) || (this.$t('userGroups.unknowErr').toString()) };
      this.$store.commit('displayMessage', message);
    });
  }

  deleteUserNameForLargeCustomer(response : any, partyGroupId : any) {
    const newRespone = response;
    const ugIndex = newRespone.userGroups.findIndex((ele : any) => ele.partyGroupId === partyGroupId);
    newRespone.userGroups.splice(ugIndex , 1);
    this.saveForageDataForUserGroup(newRespone, partyGroupId);
  }

  onMakeDefault(partyGroupId: any) {
    this.$store.commit('startLoading');
    this.makeDefaultGroup.GroupId = partyGroupId;
    MswApiService.createCustomer.manageDefaultGroup(this.makeDefaultGroup)
      .then((resp: any) => {
        if (resp.operationStatus === 'NOK') {
          const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
          this.$store.commit('displayMessage', message);
        } else {
          this.fetchUserGroupsForSelectedTenant(this.selectedCustomer[0]);
        }
      })
      .catch((error: any) => {
        const message: InfoState = { infoType: 'high', infoMsg: (error && error.message) || (this.$t('userGroups.unknowErr').toString()) };
        this.$store.commit('displayMessage', message);
      })
      .finally(() => {
        this.$store.commit('stopLoading');
      });
  }

  makeDefaultforLargeCustomer(response : any, partyGroupId : any) {
    const newResponse = response;
    const oldDefaultIndex = newResponse.userGroups.findIndex((ele : any) => ele.isDefaultGroup.toLowerCase() === 'true');
    if (oldDefaultIndex >= 0) {
      newResponse.userGroups[oldDefaultIndex].isDefaultGroup = 'false';
      newResponse.userGroups[oldDefaultIndex].setDefaultGroupLink = 'true';
    }
    const newDefaultIndex = newResponse.userGroups.findIndex((ele : any) => ele.partyGroupId === partyGroupId);
    if (newDefaultIndex >= 0) {
      newResponse.userGroups[newDefaultIndex].isDefaultGroup = 'true';
      newResponse.userGroups[newDefaultIndex].setDefaultGroupLink = 'false';
    }
    this.saveForageDataForUserGroup(newResponse, partyGroupId);
    const oldDefaultIndex1 = this.newUserGroupResponse.findIndex((ele : any) => ele.isDefaultGroup.toLowerCase() === 'true');
    if (oldDefaultIndex1 >= 0) {
      this.newUserGroupResponse[oldDefaultIndex1].isDefaultGroup = 'false';
      this.newUserGroupResponse[oldDefaultIndex1].setDefaultGroupLink = 'true';
    }
    this.$set(this.newUserGroupResponse, oldDefaultIndex1, this.newUserGroupResponse[oldDefaultIndex1]);
    const newDefaultIndex1 = this.newUserGroupResponse.findIndex((ele : any) => ele.partyGroupId === partyGroupId);
    if (newDefaultIndex1 >= 0) {
      this.newUserGroupResponse[newDefaultIndex1].isDefaultGroup = 'true';
      this.newUserGroupResponse[newDefaultIndex1].setDefaultGroupLink = 'false';
    }
    this.$set(this.newUserGroupResponse, newDefaultIndex1, this.newUserGroupResponse[newDefaultIndex1]);
    this.loadCustomerWithoutApi('', '', false);

  }

  removeUser(user: any) {
    const usersTobeDeleted = {
      bsendMail: true,
      contactLists: [{
        partyGroupId: this.selectedUser[0].partyGroupId || this.addUsersId,
        partyId: user.partyId,
        action: 'delete',
      }],
    };
    this.$store.commit('startLoading');
    MswApiService.createCustomer.manageUsers(usersTobeDeleted)
    .then((resp: any) =>  {
      if (resp.operationStatus === 'NOK') {
        const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
        this.$store.commit('displayMessage', message);
      } else {
        if (this.$store.getters.isLargeCustomer) {
          this.removeUserFromUserGroup(usersTobeDeleted);
        } else {
          this.refreshUserGroupsAndExtension(usersTobeDeleted.contactLists[0].partyGroupId);
        }
        const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
        this.$store.commit('displayMessage', message);
      }
    })
    .catch((error: any) => {
      const message: InfoState = { infoType: 'high', infoMsg: (error && error.message) || (this.$t('userGroups.unknowErr').toString()) };
      this.$store.commit('displayMessage', message);
    })
    .finally(() => {
      this.$store.commit('stopLoading');
    });
  }
  removeUserFromUserGroup(usersTobeDeleted : any) {
    this.calUpdateUserCount = false;
    this.callUpdatePermission = false;
    this.$store.commit('startLoading');
    MswApiService.createCustomer.getUserGroup()
      .then((resp: any) => {
        const changedResponse = localForageService.deleteUserFromUserGroup(usersTobeDeleted, resp);
        this.selectedUser[0].usersForUserGroup = changedResponse.respOut.userGroups[changedResponse.ugIndexChanged].usersForUserGroup;
        // tslint:disable-next-line:max-line-length
        const ugIndexInNewUserGroupResponse = this.newUserGroupResponse.findIndex((ele : any) => ele.partyGroupId === usersTobeDeleted.contactLists[0].partyGroupId);
        // tslint:disable-next-line:max-line-length
        this.newUserGroupResponse[ugIndexInNewUserGroupResponse].usersForUserGroup = changedResponse.respOut.userGroups[changedResponse.ugIndexChanged].usersForUserGroup;
        this.callUpdatePermission = true;
        this.calUpdateUserCount = true;
        // tslint:disable-next-line:max-line-length
        this.userGroupIdUpdate = `${changedResponse.respOut.userGroups[changedResponse.ugIndexChanged].partyGroupId},${usersTobeDeleted.contactLists[0].partyId}`;
        this.saveForageDataForUserGroup(changedResponse.respOut, '');
      })
      .catch((error: any) => {
        const message: InfoState = { infoType: 'high', infoMsg: (error && error.message) || (this.$t('userGroups.unknowErr').toString()) };
        this.$store.commit('displayMessage', message);
      })
      .finally(() => {
        this.$store.commit('stopLoading');
      });
  }

  addNewUser(id: string) {
    this.createUserModal = true;
    this.createCustomerModal = false;
    this.addUsersId = id;
    this.loadUsers();
    this.changeStyle('NO');
  }

  addNewCustomer(id : any) {
    this.loadCustomers();
    this.createUserModal = false;
    const customerSelected = this.selectedCustomerResponse.map((ele : any) => ele.productGroupName);
    this.$store.commit('MswUserGroupStoreModule/mutate', { property: 'initialSelectedList', with: customerSelected.sort() });
    this.createCustomerModal = true;
    this.addUsersId = id;
  }

  loadCustomers() {
    this.customersListResponse = this.newUserGroupResponse.filter((item: any) => item.partyGroupId === this.addUsersId)[0].availableProductGroup;
    this.selectedCustomerResponse = this.newUserGroupResponse.filter((item: any) => item.partyGroupId === this.addUsersId)[0].assignedProductGroup;
  }

  addedCustomers(data: any) {
    const dataToBeManaged:any = {
      partyProductGroupList: [],
      bsendMail: false,
    };
    data.map((ele: any) => {
      dataToBeManaged.partyProductGroupList.push({
        productGroupId: ele.productGroupId,
        partyGroupId: this.addUsersId,
      });
    });
    this.$store.commit('startLoading');
    MswApiService.createCustomer.postManageUserProductGroup(dataToBeManaged)
    .then((resp: any) => {
      if (resp.operationStatus === 'NOK') {
        const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
        this.$store.commit('displayMessage', message);
      } else {
        const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
        this.$store.commit('displayMessage', message);
      }
    })
    .then(() => {
      this.newUserGroupResponse = [];
    })
    .then(() => {
      this.loadDefaultGroup();
    })
    .catch((error: ApiError) => {
      this.$store.commit('stopLoading');
      this.loadDefaultGroup();
      const message: InfoState = { infoType: 'high', infoMsg: error.message || (this.$t('userGroups.unknowErr')
      .toString()) };
      this.$store.commit('displayMessage', message);
    });
  }

  addedUsers(data: any) {
    const selectedUserList: any = [];
    this.usersListResponseCopy = this.usersListResponse;
    data.map((obj: any) => {
      if (obj.hasOwnProperty('invited')) {
        selectedUserList.push(obj);
      } else {
        selectedUserList.push(this.usersListResponse.filter((item: any) => item.emailAddress === obj));
      }
    });
    const usersTobeAdded: any = {
      bsendMail: true,
      contactLists: [],
    };
    selectedUserList.map((obj: any) => {
      if (obj[0].hasOwnProperty('invited')) {
        // invited users handled via inviteUser()
      } else {
        usersTobeAdded.contactLists.push({
          partyGroupId: this.addUsersId,
          partyId: obj[0].partyId,
          action: 'add',
        });
      }
    });
    if (usersTobeAdded.contactLists.length > 0) {
      this.manageUserApi(usersTobeAdded);
    }
  }

  inviteUser(data: any) {
    const usersToBeInvited: any = {
      contactTypeId: '10001',
    };
    usersToBeInvited.partyGroupId = this.addUsersId;
    usersToBeInvited.emailAddress = data.emailAddress;
    usersToBeInvited.firstName = data.firstName;
    usersToBeInvited.lastName = data.lastName;
    usersToBeInvited.contactTypeId = data.contactTypeId;
    if (usersToBeInvited.hasOwnProperty('partyGroupId')) {
      const userGroup = this.customerList[this.customerListId].userGroupResponse.filter((data:any) => (data.partyGroupId === this.addUsersId));
      if (userGroup.length > 0 && userGroup[0].isDefaultGroup.toLowerCase() === 'true' && data.contactTypeId === '10015') {
        this.$store.commit('clearEnqueMessage');
        // tslint:disable-next-line:max-line-length
        const message :InfoState = { infoMsg : (this.$t('userGroups.cannotAddReseller')
        .toString()), infoType : 'failed' };
        this.$store.commit('enqueueMessage', message);
        return;
      }
      const email = JSON.parse(localStorage.getItem(currentUserKey) as any).email;
      // tslint:disable-next-line:max-line-length
      if (email && email.split('@')[1] !== data.emailAddress.split('@')[1] && data.contactTypeId === '10001' && userGroup.length > 0 && userGroup[0].isDefaultGroup.toLowerCase() === 'true') {
        this.buttons = [
          { key: 'cancel', name: 'Cancel', isDefault: true },
          { key: 'yes', name: 'Yes' },
        ];
        this.options = {
          status: 'high',
          title: (this.$t('products.confirmation')
          .toString()),
          // tslint:disable-next-line:no-unused
          message : (h: CreateElement): VNode => {
            return h('div', {
              // tslint:disable-next-line:max-line-length
              domProps: { innerHTML: (this.$t('userGroups.addUserToDefault')
              .toString()) },
            });
          },
          buttons: this.buttons,
        };
        confirmService.confirm(this.options)
        .then((key) => {
          if (key === 'yes') {
            this.inviteUsers(usersToBeInvited, false);
          }
        });
      } else {
        this.inviteUsers(usersToBeInvited, false);
      }
    }
  }
  refreshUserGroupsAndExtension(partyGroupId: string) {
    const tenantId = this.customerList[this.customerListId] && this.customerList[this.customerListId].productGroupId;
    if (!tenantId) { return; }
    this.callUpdatePermission = false;
    this.$store.commit('startLoading');
    this.fetchAndSetUserGroupsForCustomer(tenantId, this.customerListId)
      .then(() => {
        const fromAvailable = this.customerList[this.customerListId].userGroupResponse
          ? this.customerList[this.customerListId].userGroupResponse.filter((d: any) => d.partyGroupId === partyGroupId)
          : [];
        const fromSelected = this.customerList[this.customerListId].selectedGroup
          ? this.customerList[this.customerListId].selectedGroup.filter((d: any) => d.partyGroupId === partyGroupId)
          : [];
        const refreshed = fromAvailable.length ? fromAvailable : fromSelected;
        if (refreshed.length) {
          delete refreshed[0].permissionsForUserGroup;
          this.selectedUser = refreshed;
        }
        const currentPartyGroupId = this.selectedUser[0] && this.selectedUser[0].partyGroupId;
        MswApiService.createCustomer.getUserGroupPermissions(currentPartyGroupId || partyGroupId)
          .then((respPermission: any) => {
            const permissionObj = respPermission && respPermission.content && respPermission.content.PartyGroupPermissionSections
              ? respPermission.content.PartyGroupPermissionSections : [];
            if (this.selectedUser[0]) {
              this.$set(this.selectedUser[0], 'permissionsForUserGroup', permissionObj);
            }
            MswApiService.createCustomer.listUsersForUserGroup(currentPartyGroupId || partyGroupId)
              .then((usersResponse: any) => {
                if (usersResponse.operationStatus === 'OK' && this.selectedUser[0]) {
                  const rawUsers = usersResponse.content && usersResponse.content.assignedusers
                    ? usersResponse.content.assignedusers : [];
                  this.selectedUser[0].usersForUserGroup = rawUsers.map((u: any) => ({
                    id: u.partyId,
                    name: u.fullName,
                    email: u.emailAddress,
                    lastAccessDate: u.lastAccessDate,
                    lastAccessTime: u.lastAccessTime,
                    isReadOnlyAccess: u.isReadOnlyAccess,
                    partyId: u.partyId,
                  }));
                }
              })
              .catch((err: any) => {
                console.error('listUsersForUserGroup failed', err);
              })
              .finally(() => {
                this.callUpdatePermission = true;
                this.$store.commit('stopLoading');
              });
          })
          .catch((err: any) => {
            console.error('getUserGroupPermissions failed', err);
            this.callUpdatePermission = true;
            this.$store.commit('stopLoading');
          });
      })
      .catch((error: any) => {
        const message: InfoState = { infoType: 'high', infoMsg: (error && error.message) || (this.$t('userGroups.unknowErr').toString()) };
        this.$store.commit('displayMessage', message);
        this.$store.commit('stopLoading');
      });
  }
  manageUserApi(data: any) {
    this.callUpdatePermission = false;
    this.$store.commit('startLoading');
    this.calUpdateUserCount = false;
    MswApiService.createCustomer.manageUsers(data)
    .then((resp: any) =>  {
      this.selectedUser[0].usersForUserGroup.splice(0, this.selectedUser[0].usersForUserGroup.length); // ??
      if (this.$store.getters.isLargeCustomer) {
        this.$store.commit('startLoading');
        MswApiService.createCustomer.getUserGroup()
            .then((resp: any) => {
              let response = resp;
              const changedResponse = localForageService.addUserToUserGroup(response, data, this.usersListResponseCopy, this.newUserGroupResponse);
              this.newUserGroupResponse = changedResponse.userGroupResponseOut;
              response = changedResponse.respOut;
              this.selectedUser[0].usersForUserGroup = this.newUserGroupResponse[changedResponse.index].usersForUserGroup;
              this.$set(this.newUserGroupResponse , changedResponse.index, this.newUserGroupResponse[changedResponse.index]);
              this.saveForageDataForUserGroup(response, '');
              this.callUpdatePermission = true;
              this.userGroupIdUpdate = `${data.contactLists[0].partyGroupId},count,${this.selectedUser[0].usersForUserGroup.length}`;
              this.calUpdateUserCount = true;
            })
            .catch((error: any) => {
              const message: InfoState = { infoType: 'high', infoMsg: (error && error.message) || (this.$t('userGroups.unknowErr').toString()) };
              this.$store.commit('displayMessage', message);
            })
            .finally(() => {
              this.$store.commit('stopLoading');
            });
      } else {
        this.$store.commit('stopLoading');
        this.refreshUserGroupsAndExtension(data.contactLists[0].partyGroupId);
      }
      if (resp.operationStatus === 'NOK') {
        const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
        this.$store.commit('displayMessage', message);
      } else {
        const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
        this.$store.commit('displayMessage', message);
      }
    })
    .catch((error: any) => {
      this.$store.commit('stopLoading');
      const message: InfoState = { infoType: 'high', infoMsg: (error && error.message) || (this.$t('userGroups.unknowErr').toString()) };
      this.$store.commit('displayMessage', message);
    });
  }
  loadUserGroup() {
    this.callUpdatePermission = false;
    this.$store.commit('startLoading');
    MswApiService.createCustomer.getUserGroup()
    .then((resp: any) => {
      for (let i = 0; i < resp.userGroups.length; i += 1) {
        if (resp.userGroups[i].partyGroupId === this.selectedUser[0].partyGroupId) {
          this.selectedUser[0].usersForUserGroup = resp.userGroups[i].usersForUserGroup;
          this.newUserGroupResponse[i].usersForUserGroup = resp.userGroups[i].usersForUserGroup;
          if (this.customerListId > -1) {
            const obj = this.createAndStoreCustomerObjects(this.customerList[this.customerListId]);
            this.$set(this.customerList, this.customerListId, obj);
          }
          this.callUpdatePermission = true;
          break;
        }
      }
    })
    .catch((error: any) => {
      const message: InfoState = { infoType: 'high', infoMsg: (error && error.message) || (this.$t('userGroups.unknowErr').toString()) };
      this.$store.commit('displayMessage', message);
    })
    .finally(() => {
      this.$store.commit('stopLoading');
    });
  }
  loadUserGroupForLargeCustomer(partyGroupId : any) {
    this.callUpdatePermission = false;
    this.$store.commit('startLoading');
    MswApiService.createCustomer.getUserGroup(true)
    .then((resp: any) => {
      for (let i = 0; i < resp.userGroups.length; i += 1) {
        if (resp.userGroups[i].partyGroupId === partyGroupId) {
          this.selectedUser[0].usersForUserGroup = resp.userGroups[i].usersForUserGroup;
          this.newUserGroupResponse[i].usersForUserGroup = resp.userGroups[i].usersForUserGroup;
          this.loadCustomerWithoutApi('' , '' , true);
          this.callUpdatePermission = true;
          break;
        }
      }
    })
    .catch((error: any) => {
      const message: InfoState = { infoType: 'high', infoMsg: (error && error.message) || (this.$t('userGroups.unknowErr').toString()) };
      this.$store.commit('displayMessage', message);
    })
    .finally(() => {
      this.$store.commit('stopLoading');
    });
  }

  inviteUsers(data: any, booleanVal? : any) {
    this.updateCountFlag = false;
    this.$store.commit('startLoading');
    MswApiService.createCustomer.addUsers(data, booleanVal)
    .then((resp: any) =>  {
      if (resp.msgCode === 'MSWAPP:ADDUSERWARNING') {
        this.confirmAdd(data, resp.msgDesc);
      } else if (resp.operationStatus === 'NOK') {
        const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
        this.$store.commit('displayMessage', message);
      } else {
        if (this.$store.getters.isLargeCustomer) {
          MswApiService.createCustomer.getUserGroup()
          .then((res: any) => {
            const changedUserGroupIndex = res.userGroups.findIndex((ele : any) => ele.partyGroupId === data.partyGroupId);
            if (res.userGroups[changedUserGroupIndex].hasOwnProperty('usersForUserGroup')) {
              res.userGroups[changedUserGroupIndex].usersForUserGroup.push(resp.addedUserDetail);
            } else {
              let tempObj: any = res.userGroups[changedUserGroupIndex];
              tempObj = Object.assign(tempObj, {
                usersForUserGroup: [resp.addedUserDetail],
                initialUsers: [resp.addedUserDetail],
              });
              res.userGroups.splice(changedUserGroupIndex, 1, tempObj);
            }
            const ugIndex = this.newUserGroupResponse.findIndex((ele : any) => ele.partyGroupId === data.partyGroupId);
            this.newUserGroupResponse[ugIndex] = res.userGroups[changedUserGroupIndex];
            let customerUGListIndex = this.customerList[this.customerListId].userGroupResponse.findIndex((ele : any) => ele.partyGroupId === data.partyGroupId);
            if (customerUGListIndex > -1) {
              this.customerList[this.customerListId].userGroupResponse[customerUGListIndex] = res.userGroups[changedUserGroupIndex];
              this.selectedUser =  this.customerList[this.customerListId].userGroupResponse.filter((data:any) => (data.partyGroupId === this.selectedPartyId));
            } else {
              customerUGListIndex = this.customerList[this.customerListId].selectedGroup.findIndex((ele : any) => ele.partyGroupId === data.partyGroupId);
              if (customerUGListIndex > -1) {
                this.customerList[this.customerListId].selectedGroup[customerUGListIndex] = res.userGroups[changedUserGroupIndex];
                this.selectedUser =  this.customerList[this.customerListId].selectedGroup.filter((data:any) => (data.partyGroupId === this.selectedPartyId));
              }
            }
            this.$set(this.customerList , this.customerListId , this.customerList[this.customerListId]);
            this.$set(this.newUserGroupResponse, 0, this.newUserGroupResponse[0]);
            this.saveForageDataForUserGroup(res, res.userGroups[changedUserGroupIndex].partyGroupId);
            this.updateCountFlag = true;
          });
          this.$store.commit('stopLoading');
          this.modalClose();
          const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
          this.$store.commit('displayMessage', message);
        } else {
          this.$store.commit('stopLoading');
          this.loadUserGroup();
          this.modalClose();
          const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
          this.$store.commit('displayMessage', message);
        }
        // this.loadUsers(true);
      }
    })
    .catch((error: any) => {
      this.$store.commit('stopLoading');
      const message: InfoState = { infoType: 'high', infoMsg: (error && error.message) || (this.$t('userGroups.unknowErr').toString()) };
      this.$store.commit('displayMessage', message);
    });
  }
  confirmAdd(data : any, resp : any) {
    this.buttons = [
      { key: 'cancel', name: 'Cancel', isDefault: true },
      { key: 'yes', name: 'Yes' },
    ];
    this.options = {
      status: 'high',
      title: (this.$t('products.confirmation')
      .toString()),
      message: resp,
      buttons: this.buttons,
    };
    confirmService.confirm(this.options)
    .then((key) => {
      if (key === 'yes') {
        this.$store.commit('startLoading');
        MswApiService.createCustomer.addUsers(data, true)
    .then((resp: any) =>  {
      this.$store.commit('stopLoading');
      if (resp.msgCode === 'MSWAPP:ADDUSERWARNING') {
        this.confirmAdd(data, resp.msgDesc);
      } if (resp.operationStatus === 'NOK') {
        const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
        this.$store.commit('displayMessage', message);
      } else {
        this.$store.commit('startLoading');
        this.modalClose();
        const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
        this.$store.commit('displayMessage', message);
        this.loadUsers(true);
        // this.loadDefaultGroup();
      }
    });
      } else {
      }
    });
  }

  modalClose() {
    this.createUserModal = false;
    this.createCustomerModal = false;
    this.showTenantDetail = false;
  }

  loadUsers(val?: any) {
    if (!this.$store.getters.isLargeCustomer || val) {
      this.$store.commit('startLoading');
    } else {
      this.showLoading = true;
    }
    MswApiService.createCustomer.listUsersForUserGroup(this.addUsersId)
    .then((resp: any) => {
      if (val) {
        this.usersListResponse = resp.hasOwnProperty('content') ? resp.content.hasOwnProperty('availbleUsers') ? resp.content.availbleUsers : [] : [];
        // this.loadDefaultGroup();
        if (this.$store.getters.isLargeCustomer) {
          idb.refreshStore(USERGROUP_STORE_NAME)
            .then(() => {
              this.loadUserGroupForLargeCustomer(this.addUsersId);
              // this.loadUserGroupTemp();
            });
        } else {
          // this.loadUserGroupTemp();
          this.loadUserGroupForLargeCustomer(this.addUsersId);
        }
      } else {
        this.showLoading = false;
        this.usersListResponse = resp.hasOwnProperty('content') ? resp.content.hasOwnProperty('availbleUsers') ? resp.content.availbleUsers : [] : [];
      }
    })
    .catch((error: any) => {
      this.showLoading = false;
      const message: InfoState = { infoType: 'high', infoMsg: (error && error.message) || (this.$t('userGroups.unknowErr').toString()) };
      this.$store.commit('displayMessage', message);
    })
    .finally(() => {
      if (!this.$store.getters.isLargeCustomer || val) {
        this.$store.commit('stopLoading');
      }
    });
  }

  loadDefaultGroup(forced = false) {
    this.newUserGroupResponse = [];
    this.defaultUserGroup = [];
    this.$store.commit('startLoading');
    this.forceFetch = forced;
    MswApiService.createCustomer.getProductGroupList('createCustomer')
      .then((resp: any) => {
        this.showTenantTransfer = resp.showTenantTransfer === 'YES';
        if (resp.defPartyGroupID) {
          this.defaultGroupId = resp.defPartyGroupID;
          this.enableNewCustomer = true;
        } else {
          this.enableNewCustomer = false;
        }
        const cannotCreate = !this.enableNewCustomer;
        if (resp.showCreateProductGrplink === 'true' && cannotCreate) {
          const message: InfoState = { infoType: 'major', infoMsg: (this.$t('userGroups.cannotCreateNewTenant').toString()) };
          this.$store.commit('enqueueMessage', message);
        }
        if (resp.hasOwnProperty('userGroups') && resp.userGroups.length > 0) {
          this.addUserGroup = resp.showCreateUserGrplink && resp.showCreateUserGrplink.toLowerCase() === 'true';
          if (this.$store.getters.isLargeCustomer) {
            this.loadUGForLargeCustomer(resp, null, resp);
          } else {
            this.loadPermission(resp, resp);
          }
          this.userGroupCount = resp.userGroups.length;
        } else {
          this.newUserGroupResponse = [];
          this.loadCustomerList(resp);
        }
      })
      .catch(() => {
        this.$store.commit('stopLoading');
      });
  }
  loadUGForLargeCustomer(resp : any, response = null, cachedResp: any = null) {
    this.newUserGroupResponse = [];
    const defaultIndex = resp.userGroups.findIndex((ele : any) => ele.isDefaultGroup.toLowerCase() === 'true');
    this.enableNewCustomer = true;
    if (defaultIndex > -1) {
      this.defaultGroupId = resp.userGroups[defaultIndex].partyGroupId;
      let tempObj: any = resp.userGroups[defaultIndex];
      tempObj = Object.assign(tempObj, {
        // tslint:disable-next-line:max-line-length
        usersForUserGroup: resp.userGroups[defaultIndex].hasOwnProperty('usersForUserGroup') ? resp.userGroups[defaultIndex].usersForUserGroup.map((users: any) => {
          return users;
        }) : [],
        permissionsForUserGroup: [],
        // tslint:disable-next-line:max-line-length
        initialUsers: resp.userGroups[defaultIndex].hasOwnProperty('usersForUserGroup') ? resp.userGroups[defaultIndex].usersForUserGroup.map((users: any) => {
          return users;
        }) : [],
      });
      this.defaultUserGroup.push(tempObj);
      this.newUserGroupResponse.push(tempObj);
      resp.userGroups.splice(defaultIndex, 1);
      this.newUserGroupResponse = this.newUserGroupResponse.concat(resp.userGroups);
      if (this.defaultGroupId !== '' && this.$store.getters.isLargeCustomer && this.noEarlySpinner) {
        this.showInitialLoader = true;
        this.$store.commit('stopLoading');
      }
      if (this.isHardRefresh && response !== null) {
        this.loadCustomerListOnHardRefresh(response);
      } else {
        this.loadCustomerList(cachedResp);
      }
    } else {
      this.newUserGroupResponse = this.newUserGroupResponse.concat(resp.userGroups);
      if (this.defaultGroupId !== '' && this.$store.getters.isLargeCustomer && this.noEarlySpinner) {
        this.showInitialLoader = true;
        this.$store.commit('stopLoading');
      }
      if (this.isHardRefresh && response !== null) {
        this.loadCustomerListOnHardRefresh(response);
      } else {
        this.loadCustomerList(cachedResp);
      }
    }
  }

  loadPermission(resp : any, cachedResp: any = null) {
    this.newUserGroupResponse = [];
    for (let i = 0; i < resp.userGroups.length; i += 1) {
      const obj = resp.userGroups[i];
      let tempObj: any = resp.userGroups[i];
      if (tempObj.isDefaultGroup.toLowerCase() === 'true') {
        this.enableNewCustomer = true;
        this.defaultGroupId = tempObj.partyGroupId;
        tempObj = Object.assign(tempObj, {
          usersForUserGroup: obj.hasOwnProperty('usersForUserGroup') ? obj.usersForUserGroup.map((users: any) => {
            return users;
          }) : [],
          permissionsForUserGroup: [],
          initialUsers: obj.hasOwnProperty('usersForUserGroup') ? obj.usersForUserGroup.map((users: any) => {
            return users;
          }) : [],
        });
        this.defaultUserGroup.push(tempObj);
        this.newUserGroupResponse.push(tempObj);
        if (this.newUserGroupResponse.length === resp.userGroups.length) {
          if (this.defaultGroupId !== '' && this.$store.getters.isLargeCustomer && this.noEarlySpinner) {
            this.showInitialLoader = true;
            this.$store.commit('stopLoading');
          }
          if (this.loadCustomerWithoutApiFlag) {
            this.loadCustomerWithoutApiFlag = false;
            this.loadCustomerWithoutApi('', '', false);
          } else {
            this.loadCustomerList(cachedResp);
          }
        }
      } else {
        if (i < 5 || this.selectedUser.partyGroupId === tempObj.partyGroupId) {
          tempObj = Object.assign(tempObj, {
            usersForUserGroup: obj.hasOwnProperty('usersForUserGroup') ? obj.usersForUserGroup : [],
            permissionsForUserGroup: [],
            initialUsers: obj.hasOwnProperty('usersForUserGroup') ? obj.usersForUserGroup.map((users: any) => {
              return users;
            }) : [],
          });
          if (this.newGroupAddedFlag && this.selectedCustomer[this.selectedCustomer.length - 1] === tempObj.partyGroupName) {
            this.newUserGroupResponse.splice(0 , 0 , tempObj);
              // this.loadCustomerList();
            this.newGroupAddedFlag = false;
          } else {
            if (this.selectedUser.length > 0) {
              if (this.selectedUser.partyGroupId === tempObj.partyGroupId) {
                this.newUserGroupResponse.unshift(tempObj);
              } else {
                this.newUserGroupResponse.push(tempObj);
              }
            } else if (this.newGroupAddedFlagSmallCustomer && !this.$store.getters.isLargeCustomer && obj.partyGroupName.trim()
                      .toLowerCase() === this.newUserGroup.trim()
                      .toLowerCase()) {
              this.newUserGroupResponse.splice(0 , 0 , tempObj);
              this.newGroupAddedFlagSmallCustomer = false;
            } else {
              this.newUserGroupResponse.push(tempObj);
            }
          }
          if (this.newUserGroupResponse.length === resp.userGroups.length) {
            if (this.defaultGroupId !== '' && this.$store.getters.isLargeCustomer && this.noEarlySpinner) {
              this.showInitialLoader = true;
              this.$store.commit('stopLoading');
            }
            if (this.loadCustomerWithoutApiFlag) {
              this.loadCustomerWithoutApiFlag = false;
              this.loadCustomerWithoutApi('', '', false);
            } else {
              this.loadCustomerList(cachedResp);
            }
          }
        } else {
          tempObj = Object.assign(tempObj, {
            usersForUserGroup: obj.hasOwnProperty('usersForUserGroup') ? obj.usersForUserGroup.map((users: any) => {
              return users;
            }) : [],
            initialUsers: obj.hasOwnProperty('usersForUserGroup') ? obj.usersForUserGroup.map((users: any) => {
              return users;
            }) : [],
          });
          if (this.newGroupAddedFlag && this.selectedCustomer[this.selectedCustomer.length - 1] === tempObj.partyGroupName) {
            this.newUserGroupResponse.splice(0 , 0 , tempObj);
            // this.loadCustomerList();
            this.newGroupAddedFlag = false;
          }  else if (this.newGroupAddedFlagSmallCustomer && !this.$store.getters.isLargeCustomer && obj.partyGroupName.trim()
                          .toLowerCase() === this.newUserGroup.trim()
                          .toLowerCase()) {
            this.newUserGroupResponse.splice(0 , 0 , tempObj);
            this.newGroupAddedFlagSmallCustomer = false;
          } else if (this.selectedUser.length > 0) {
            if (this.selectedUser.partyGroupId === tempObj.partyGroupId) {
              this.newUserGroupResponse.unshift(tempObj);
            } else {
              this.newUserGroupResponse.push(tempObj);
            }
          } else {
            this.newUserGroupResponse.push(tempObj);
          }
          if (this.newUserGroupResponse.length === resp.userGroups.length) {
            if (this.defaultGroupId !== '' && this.$store.getters.isLargeCustomer && this.noEarlySpinner) {
              this.showInitialLoader = true;
              this.$store.commit('stopLoading');
            }
            if (this.loadCustomerWithoutApiFlag) {
              this.loadCustomerWithoutApiFlag = false;
              this.loadCustomerWithoutApi('', '', false);
            } else {
              this.loadCustomerList(cachedResp);
            }
          }
        }
      }
      this.newSelectedGroup = this.defaultUserGroup;
    }
    // this.userGroupCount = resp.hasOwnProperty('userGroups') ? resp.userGroups.length : 0;
  }

  loadCustomerList(cachedResp: any = null) {
    if (cachedResp && !this.$store.getters.isLargeCustomer) {
      this.then1Execution(cachedResp);
      this.then2Execution();
      this.then3Execution();
      return;
    }
    if (this.$store.getters.isLargeCustomer) {
      this.$store.dispatch('DashBoardStoreModule/populateCustomerWidgets', this.forceFetch)
      .then((response: any) => {
        this.forceFetch = false;
        const resp : any = {};
        resp['showAddProductGrplink'] = response.showAddProductGrplink;
        resp['showCreateProductGrplink'] = response.showCreateProductGrplink;
        resp['showTenantInfo'] = response.showTenantInfo;
        resp['productGroup'] = response.prodGroupLicenseStatus;
        this.then1Execution(resp);
        this.then2Execution();
        this.then3Execution();
      })
      .catch(() => {
        this.$store.commit('stopLoading');
        this.enterNewCustomer ? this.focusCreateCustomerTextbox() : '';
      });
    } else {
      MswApiService.createCustomer.getProductGroupList('createCustomer')
      .then((resp: any) => {
        if (resp.showCreateProductGrplink === 'true') {
          if (!this.enableNewCustomer) {
            // tslint:disable-next-line:max-line-length
            const message: InfoState = { infoType: 'major', infoMsg: (this.$t('userGroups.cannotCreateNewTenant')
            .toString()) };
            this.$store.commit('enqueueMessage', message);
          }
        } else {
          this.enableNewCustomer = false;
        }
        this.showTenantTransfer = resp.showTenantTransfer === 'YES';
        this.then1Execution(resp);
        this.then2Execution();
        this.then3Execution();
      })
      .catch(() => {
        this.$store.commit('stopLoading');
        this.enterNewCustomer ? this.focusCreateCustomerTextbox() : '';
      });
    }
  }

  then1Execution(resp : any) {
    this.showTenantInfo = resp.showTenantInfo;
    this.productGroupList = [];
    this.productGroupList = resp.productGroup;
    if (this.$store.getters.isLargeCustomer) {
      // tslint:disable-next-line:max-line-length
      const ind = this.productGroupList.findIndex((ele : any) => ele.isDefaultGroup.toLowerCase() === 'true' && ele.isSharedProductGroup.toLowerCase() !== 'true');
      if (ind >= 0) {
        this.defaultCustomer = this.productGroupList[ind];
      }
    } else {
      // tslint:disable-next-line:max-line-length
      const ind = this.productGroupList.findIndex((ele : any) => ele.isDefaultGroup.toLowerCase() === 'true' && ele.sharedGroup.toLowerCase() !== 'true');
      if (ind >= 0) {
        this.defaultCustomer = this.productGroupList[ind];
      }
    }
    this.newCustomerCount = resp.productGroup || 0;
    if (this.newCustomer.trim() !== '') {
      const customerIndex = this.productGroupList.findIndex((ele: any) => ele.productGroupName === this.newCustomer);
      if (customerIndex !== undefined) {
        if (customerIndex !== -1) {
          const customerObj = this.productGroupList[1];
          this.productGroupList[1] = this.productGroupList[customerIndex];
          this.productGroupList.splice(customerIndex, 1);
          this.productGroupList.push(customerObj);
        }
      }
      this.newCustomer = '';
    }
  }
  then2Execution() {
    const tempResponse = this.newUserGroupResponse;
    const indTemp = tempResponse.findIndex((ele : any) => ele.isDefaultGroup.toLowerCase() === 'true');
    if (indTemp > -1) {
      const copyObj = tempResponse[indTemp];
      this.newUserGroupResponse.splice(indTemp, 1);
      this.newUserGroupResponse.unshift(copyObj);
    }
    const lastSelected = this.selectedCustomer.length > 0 ? this.selectedCustomer[0] : '';
    this.customerList = [];
    if (this.showMsspButtons && this.selectedTenantIdForMSSP === '') {
      const index = this.productGroupList.findIndex((ele : any) => ele.productGroupName === this.selectedCustomer[0]);
      this.selectedTenantIdForMSSP = this.productGroupList[index].productGroupId;
    }
    if (this.productGroupList.length < 100) {
      this.productGroupList.forEach((ele : any) => {
        this.customerList.push(this.createAndStoreCustomerObjects(ele));
      });
    } else {
      this.tempLoadLastIndex = 100;
      for (let i = 0; i < this.tempLoadLastIndex ; i += 1) {
        this.customerList.push(this.createAndStoreCustomerObjects(this.productGroupList[i]));
      }
    }
    if (this.selectedCustomer[0] && this.customerList.findIndex((ele : any) => ele.productGroupName === this.selectedCustomer[0]) < 0) {
      const selectedCustomerIndex = this.productGroupList.findIndex((ele : any) => ele.productGroupName === this.selectedCustomer[0]);
      this.customerList.unshift(this.productGroupList[selectedCustomerIndex]);
      this.customerListId = this.customerList.findIndex((ele : any) => ele.productGroupName === this.selectedCustomer[0]);
      this.customerList[this.customerListId] = (this.createAndStoreCustomerObjects(this.customerList[this.customerListId]));
    }
    this.tempCustomerListVariable = this.customerList;
    this.backedUpProductGroup = this.productGroupList;
    if (this.productGroupList.length > 100) {
      if (this.endTenantIndex === 0) {
        this.endTenantIndex = 100;
      }
    } else {
      this.startTenantIndex = 0;
      this.endTenantIndex = this.productGroupList.length;
    }
    this.showInitialLoader = false;
    if (this.customerCreatedBeforeApiCall.length > 0) {
      this.selectedCustomer = [];
      this.hoveredCustomer = [];
      this.customerCreatedBeforeApiCall.forEach((ele : any) => {
        const findIndex = this.productGroupList.findIndex((obj: any) => obj.productGroupId === ele.productGroupId);
        if (findIndex === -1) {
          if (lastSelected === ele.productGroupName) {
            this.selectedCustomer.push(ele.productGroupName);
          }
          this.productGroupList.splice(1, 0 , ele);
        }
      });
    }
    this.getSlicedCustomer();
  }
  then3Execution() {
    this.newCustomerCount = this.productGroupList.length;
    if (this.$store.getters.isLargeCustomer && this.noEarlySpinner) {
      (this.$refs.vscroll as SwScrollView).updatePosition(0, true);
    }
    this.$store.commit('stopLoading');
    this.enterNewCustomer ? this.focusCreateCustomerTextbox() : '';
    if (this.newlyCreatedTenantName) {
      const tenantName = this.newlyCreatedTenantName;
      this.newlyCreatedTenantName = '';
      this.fetchUserGroupsForSelectedTenant(tenantName);
    }
  }
  removeCustomer(index : any) {
    if (this.selectedUser[0].assignedProductGroup.length > 1) {
      this.$store.commit('startLoading');
      const dataToBeManaged:any = {
        partyProductGroupList: [],
        bsendMail: false,
        deletedProductGroupId: this.selectedUser[0].assignedProductGroup[index].productGroupId,
      };
      this.selectedUser[0].assignedProductGroup.splice([index], 1);
      this.selectedUser[0].assignedProductGroup.map((ele: any) => {
        dataToBeManaged.partyProductGroupList.push({
          productGroupId: ele.productGroupId,
          partyGroupId: this.addUsersId,
        });
      });
      MswApiService.createCustomer.postManageUserProductGroup(dataToBeManaged)
      .then((resp: any) => {
        this.selectedUser[0].assignedProductGroup.splice(0, this.selectedUser[0].assignedProductGroup.length); // ??
        this.loadDefaultGroup();
        if (resp.operationStatus === 'NOK') {
          const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
          this.$store.commit('displayMessage', message);
        } else {
          const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
          idb.refreshStore(PRODUCTS_STORE_NAME);
          this.$store.commit('displayMessage', message);
        }
      })
      .catch((error: any) => {
        const message: InfoState = { infoType: 'high', infoMsg: (error && error.message) || (this.$t('userGroups.unknowErr').toString()) };
        this.$store.commit('displayMessage', message);
        this.loadDefaultGroup();
      })
      .finally(() => {
        this.$store.commit('stopLoading');
      });
    } else {
      const message: InfoState = { infoType: 'high', infoMsg: (this.$t('userGroups.ensureOneProduct')
      .toString()) };
      this.$store.commit('displayMessage', message);
    }
  }

  onSelectedList(data: any, flag: boolean) {
    let added = true;
    let ugId : any;
    this.$store.commit('startLoading');
    if (flag) {
      if (this.customerList[this.customerListId].userGroupResponse[data].isDefaultGroup.toLowerCase() === 'true') {
        this.customerList[this.customerListId].selectedGroup.splice(0, 0, this.customerList[this.customerListId].userGroupResponse[data]);
        this.customerList[this.customerListId].userGroupResponse.splice([data], 1);
      } else {
        ugId = this.customerList[this.customerListId].userGroupResponse[data];
        this.customerList[this.customerListId].selectedGroup.push(this.customerList[this.customerListId].userGroupResponse[data]);
        this.customerList[this.customerListId].userGroupResponse.splice([data], 1);
      }
    } else {
      if (this.customerList[this.customerListId].selectedGroup[data].isDefaultGroup.toLowerCase() === 'true') {
        this.customerList[this.customerListId].userGroupResponse.splice(0, 0, this.customerList[this.customerListId].selectedGroup[data]);
        this.customerList[this.customerListId].selectedGroup.splice([data], 1);
      } else {
        added = false;
        ugId = this.customerList[this.customerListId].selectedGroup[data];
        this.customerList[this.customerListId].userGroupResponse.push(this.customerList[this.customerListId].selectedGroup[data]);
        this.customerList[this.customerListId].selectedGroup.splice([data], 1);
      }
    }
    const dataToBeManaged: any = {
      partyProductGroupList: [],
      bsendMail: null,
    };
    this.customerList[this.customerListId].selectedGroup.map((ele: any) => {
      dataToBeManaged.partyProductGroupList.push({
        productGroupId: this.customerList[this.customerListId].productGroupId,
        partyGroupId: ele.partyGroupId,
      });
    });
    MswApiService.createCustomer.postManageProductUserGroups(dataToBeManaged)
    .then((rsp: any) => {
      if (rsp.operationStatus === 'NOK') {
        this.$store.commit('stopLoading');
        const message: InfoState = { infoType: 'high', infoMsg: rsp.msgDesc };
        this.$store.commit('displayMessage', message);
      } else {
        const message: InfoState = { infoType: 'success', infoMsg: rsp.msgDesc };
        this.$store.commit('displayMessage', message);
        this.$store.commit('stopLoading');
        if (this.$store.getters.isLargeCustomer) {
          Promise.all([
            this.$store.dispatch('DashBoardStoreModule/populateCustomerWidgets', this.forceFetch),
            MswApiService.createCustomer.getUserGroup(false),
          ])
          .then((resp: any) => {
            // tslint:disable-next-line:max-line-length
            const changedProductGroupId = resp[0].prodGroupLicenseStatus.findIndex((ele : any) => ele.productGroupId === dataToBeManaged.partyProductGroupList[0].productGroupId);
            const changedUserGroupId = resp[1].userGroups.findIndex((ele : any) => ele.partyGroupId === ugId.partyGroupId);
            // tslint:disable-next-line:max-line-length
            const customerListIndex = this.tempCustomerListVariable.findIndex((ele : any) => ele.productGroupId === dataToBeManaged.partyProductGroupList[0].productGroupId);
            const userGroupResIndex = this.newUserGroupResponse.findIndex((ele : any) => ele.partyGroupId === ugId.partyGroupId);
            if (added) {
              if (resp[0].prodGroupLicenseStatus[changedProductGroupId].partyGroupName.trim().length > 0) {
                // tslint:disable-next-line:max-line-length
                resp[0].prodGroupLicenseStatus[changedProductGroupId].partyGroupName = `${resp[0].prodGroupLicenseStatus[changedProductGroupId].partyGroupName}, ${ugId.partyGroupName}`;
              } else {
                resp[0].prodGroupLicenseStatus[changedProductGroupId].partyGroupName = ugId.partyGroupName;
              }
              if (this.customerList[this.customerListId].productGroupId === resp[0].prodGroupLicenseStatus[changedProductGroupId].productGroupId) {
                this.customerList[this.customerListId].partyGroupName = resp[0].prodGroupLicenseStatus[changedProductGroupId].partyGroupName;
                this.$set(this.customerList, this.customerListId, this.customerList[this.customerListId]);
              }
              if (resp[1].userGroups[changedUserGroupId].productGroupName.trim().length > 0) {
                // tslint:disable-next-line:max-line-length
                resp[1].userGroups[changedUserGroupId].productGroupName = `${resp[1].userGroups[changedUserGroupId].productGroupName}^& ${resp[0].prodGroupLicenseStatus[changedProductGroupId].productGroupName}`;
              } else {
                resp[1].userGroups[changedUserGroupId].productGroupName = resp[0].prodGroupLicenseStatus[changedProductGroupId].productGroupName;
              }
              this.tempCustomerListVariable[customerListIndex].partyGroupName = resp[0].prodGroupLicenseStatus[changedProductGroupId].partyGroupName;
              this.newUserGroupResponse[userGroupResIndex].productGroupName = resp[1].userGroups[changedUserGroupId].productGroupName;
            } else {
              const partyGroupNamesIndex = resp[0].prodGroupLicenseStatus[changedProductGroupId].partyGroupName.indexOf(`${ugId.partyGroupName},`);
              if (partyGroupNamesIndex === -1) {
                // tslint:disable-next-line:max-line-length
                resp[0].prodGroupLicenseStatus[changedProductGroupId].partyGroupName = resp[0].prodGroupLicenseStatus[changedProductGroupId].partyGroupName.replace(`, ${ugId.partyGroupName}`, '');
              } else {
                // tslint:disable-next-line:max-line-length
                resp[0].prodGroupLicenseStatus[changedProductGroupId].partyGroupName = resp[0].prodGroupLicenseStatus[changedProductGroupId].partyGroupName.replace(`${ugId.partyGroupName}, `, '');
              }
              if (this.customerList[this.customerListId].productGroupId === resp[0].prodGroupLicenseStatus[changedProductGroupId].productGroupId) {
                this.customerList[this.customerListId].partyGroupName = resp[0].prodGroupLicenseStatus[changedProductGroupId].partyGroupName;
                this.$set(this.customerList, this.customerListId, this.customerList[this.customerListId]);
              }
              // tslint:disable-next-line:max-line-length
              const productGroupNameIndex = resp[1].userGroups[changedUserGroupId].productGroupName.indexOf(`${resp[0].prodGroupLicenseStatus[changedProductGroupId].productGroupName}^&`);
              if (productGroupNameIndex === -1) {
                // tslint:disable-next-line:max-line-length
                resp[1].userGroups[changedUserGroupId].productGroupName = resp[1].userGroups[changedUserGroupId].productGroupName.replace(`^& ${resp[0].prodGroupLicenseStatus[changedProductGroupId].productGroupName}`, '');
              } else {
                // tslint:disable-next-line:max-line-length
                resp[1].userGroups[changedUserGroupId].productGroupName = resp[1].userGroups[changedUserGroupId].productGroupName.replace(` ${resp[0].prodGroupLicenseStatus[changedProductGroupId].productGroupName}^& `, '');
              }
              this.tempCustomerListVariable[customerListIndex].partyGroupName = resp[0].prodGroupLicenseStatus[changedProductGroupId].partyGroupName;
              this.newUserGroupResponse[userGroupResIndex].productGroupName = resp[1].userGroups[changedUserGroupId].productGroupName;
            }
            this.saveForageData(resp[0], '');
            this.saveForageDataForUserGroup(resp[1], '');
          });
        } else {
          const tenantId = this.customerList[this.customerListId] && this.customerList[this.customerListId].productGroupId;
          if (tenantId) {
            this.$store.commit('startLoading');
            this.fetchAndSetUserGroupsForCustomer(tenantId, this.customerListId)
              .catch((error: any) => {
                const message: InfoState = { infoType: 'high', infoMsg: (error && error.message) || (this.$t('userGroups.unknowErr').toString()) };
                this.$store.commit('displayMessage', message);
              })
              .finally(() => {
                this.$store.commit('stopLoading');
              });
          }
        }
      }
    });
  }

  changePermission(id: any, value: any, functionality: any) {
    this.$store.commit('startLoading');
    MswApiService.createCustomer.changePermssion(id, value, functionality.functionalityname)
    .then((resp: any) => {
      if (resp.operationStatus === 'NOK') {
        this.loadDefaultGroup();
        const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
        this.$store.commit('displayMessage', message);
      } else {
        this.refreshUserGroupsAndExtension(id);
      }
    })
    .catch((error: any) => {
      const message: InfoState = { infoType: 'high', infoMsg: (error && error.message) || (this.$t('userGroups.unknowErr').toString()) };
      this.$store.commit('displayMessage', message);
    })
    .finally(() => {
      this.$store.commit('stopLoading');
    });
  }

  beforeDestroy() {
  }

  makeDefaultTenant(id: any, productGroupName : any) {
    this.buttons = [
      { key: 'cancel', name: 'Cancel', isDefault: true },
      { key: 'yes', name: 'Yes' },
    ];
    this.options = {
      status: 'informational',
      title: (this.$t('products.confirmation')
      .toString()),
      // tslint:disable-next-line:no-unused
      message : (h: CreateElement): VNode => {
        return h('div', {
          // tslint:disable-next-line:max-line-length
          domProps: { innerHTML: this.defaultCustomer ?
          // tslint:disable-next-line:max-line-length
          `${(this.$t('userGroups.setting1')
          .toString())} <b>${this.defaultCustomer.productGroupName}</b> to <b>${productGroupName}</b> ?` :
          // tslint:disable-next-line:max-line-length
          `${(this.$t('userGroups.setting2')
          .toString())} <b>${productGroupName}</b> ?` },
        });
      },
      buttons: this.buttons,
    };
    confirmService.confirm(this.options)
    .then((key) => {
      if (key === 'yes') {
        this.$store.commit('startLoading');
        const makeDefaultGroup: any = {
          GroupId: id.toString(),
          mode: 'TENANT',
        };
        MswApiService.createCustomer.manageDefaultGroup(makeDefaultGroup)
        .then((resp: any) => {
          if (resp.operationStatus === 'NOK') {
            const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
            this.$store.commit('displayMessage', message);
          } else {
            if (this.$store.getters.isLargeCustomer) {
              this.$store.dispatch('DashBoardStoreModule/populateCustomerWidgets')
            .then((response: any) => {
              this.makeTenantDefaultForLargeCustomer(response, id);
            });
            } else {
              this.makeTenantDefault(id);
            }
            const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
            this.$store.commit('displayMessage', message);
          }
        })
        .catch((error: any) => {
          const message: InfoState = { infoType: 'high', infoMsg: (error && error.message) || (this.$t('userGroups.unknowErr').toString()) };
          this.$store.commit('displayMessage', message);
        })
        .finally(() => {
          this.$store.commit('stopLoading');
        });
      }
    });
  }
  // tslint:disable-next-line:no-unused
  makeTenantDefaultForLargeCustomer(response : any , id : any) {
    const newResponse = response;
    const oldDefaultIndex = this.tempCustomerListVariable.findIndex((ele : any) => ele.isDefaultGroup.toLowerCase() === 'true');
    if (oldDefaultIndex >= 0) {
      this.tempCustomerListVariable[oldDefaultIndex].isDefaultGroup = 'false';
      this.tempCustomerListVariable[oldDefaultIndex].setDefaultGroupLink = 'true';
      this.productGroupList[oldDefaultIndex].isDefaultGroup = 'false';
      this.productGroupList[oldDefaultIndex].setDefaultGroupLink = 'true';
    }
    this.$set(this.tempCustomerListVariable, oldDefaultIndex, this.tempCustomerListVariable[oldDefaultIndex]);
    const newDefaultIndex = this.tempCustomerListVariable.findIndex((ele : any) => ele.productGroupId === id);
    this.tempCustomerListVariable[newDefaultIndex].isDefaultGroup = 'true';
    this.tempCustomerListVariable[newDefaultIndex].setDefaultGroupLink = 'false';
    this.productGroupList[newDefaultIndex].isDefaultGroup = 'true';
    this.productGroupList[newDefaultIndex].setDefaultGroupLink = 'false';
    this.$set(this.tempCustomerListVariable, newDefaultIndex, this.tempCustomerListVariable[newDefaultIndex]);
    const oldResponseIndex = newResponse.prodGroupLicenseStatus.findIndex((ele : any) => ele.isDefaultGroup.toLowerCase() === 'true');
    if (oldDefaultIndex >= 0) {
      newResponse.prodGroupLicenseStatus[oldResponseIndex].isDefaultGroup = 'false';
      newResponse.prodGroupLicenseStatus[oldResponseIndex].setDefaultGroupLink = 'true';
    }
    const newResponseIndex = newResponse.prodGroupLicenseStatus.findIndex((ele : any) => ele.productGroupId === id);
    newResponse.prodGroupLicenseStatus[newResponseIndex].isDefaultGroup = 'true';
    newResponse.prodGroupLicenseStatus[newResponseIndex].setDefaultGroupLink = 'false';
    this.saveForageData(newResponse, id);
    this.updateSelectedProductGroup();
    this.getSlicedCustomer();
    this.$store.commit('stopLoading');
  }
  // tslint:disable-next-line:no-unused
  makeTenantDefault(id : any) {
    this.$store.commit('startLoading');
    MswApiService.createCustomer.getProductGroupList('createCustomer')
    .then((resp: any) => {
      if (resp.operationStatus === 'OK') {
        const oldDefaultIndex = this.tempCustomerListVariable.findIndex((ele : any) => ele.isDefaultGroup.toLowerCase() === 'true');
        // tslint:disable-next-line:max-line-length
        const oldDefaultIndexNewData = resp.productGroup.findIndex((ele: any) => ele.productGroupId === this.tempCustomerListVariable[oldDefaultIndex].productGroupId);
        // tslint:disable-next-line:max-line-length
        const oldDefaultUpdatedObject = this.createAndStoreCustomerObjects(resp.productGroup[oldDefaultIndexNewData]);
        this.$set(this.tempCustomerListVariable, oldDefaultIndex, oldDefaultUpdatedObject);
        const newDefaultIndexNewData = resp.productGroup.findIndex((ele: any) => ele.isDefaultGroup.toLowerCase() === 'true');
        // tslint:disable-next-line:max-line-length
        const indexInTempCustomerListVar = this.tempCustomerListVariable.findIndex((ele : any) => ele.productGroupId === resp.productGroup[newDefaultIndexNewData].productGroupId);
        const newDefaultUpdatedObject = this.createAndStoreCustomerObjects(resp.productGroup[newDefaultIndexNewData]);
        this.$set(this.tempCustomerListVariable, indexInTempCustomerListVar, newDefaultUpdatedObject);
        this.updateSelectedProductGroup();
        this.getSlicedCustomer();
      }
    })
    .catch((error: any) => {
      const message: InfoState = { infoType: 'high', infoMsg: (error && error.message) || (this.$t('userGroups.unknowErr').toString()) };
      this.$store.commit('displayMessage', message);
    })
    .finally(() => {
      this.$store.commit('stopLoading');
    });
  }

  get getSelectedList() {
    if (this.customerListId >= 0 && this.customerList[this.customerListId] && this.customerList[this.customerListId].hasOwnProperty('selectedGroup')) {
      return this.customerList[this.customerListId].selectedGroup.map((ele: any) => {
        return ele.partyGroupName;
      });
    }
    return [];
  }

  get createCustomerTooltipValue() : TooltipDirValues  {
    return {
      enabled: this.enableCreateCustomerTooltip,
      placement: 'top',
      persistent: true,
      compact: true,
      content: this.createCustomerTooltipContent,
    };
  }

  onEnterGrpName(value: string) {
    this.enableCreateCustomerTooltip = false;
    if (value.trim() !== '') {
      if (value.length > 50) {
        this.enableCreateCustomerTooltip = true;
        this.createCustomerTooltipContent = (this.$t('userGroups.charExceed')
        .toString());
        return;
      }
    }
    this.renameCreateCustomer = value;
  }

  editProductGroup(name: string) {
    this.editFlag = true;
    this.renameCreateCustomer = name;
  }

  cancelTenant() {
    this.editFlag = false;
    this.selectedCustomer = [];
    this.hoveredCustomer = [];
    this.cancelFlag = true;
  }

  submitRenameProductGroup(id: string) {
    this.$store.commit('startLoading');
    this.editFlag = false;
    const productGroupToBeRenamed: any = {
      productGroupId: id,
      newProductGroupName: this.renameCreateCustomer,
      bSendMail: false,
    };
    MswApiService.createCustomer.renameProductGroup(productGroupToBeRenamed)
    .then((resp: any) => {
      if (resp.operationStatus === 'NOK') {
        this.renameCreateCustomer = '';
        const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
        this.$store.commit('displayMessage', message);
        this.$store.commit('stopLoading');
      } else {
        idb.refreshStore(PRODUCTS_STORE_NAME);
        this.$store.commit('startLoading');
        if (this.$store.getters.isLargeCustomer) {
          Promise.all([
            this.$store.dispatch('DashBoardStoreModule/populateCustomerWidgets', false),
            MswApiService.createCustomer.getUserGroup(false),
          ])
          .then((response: any) => {
            this.renameTenantForLargeCustomer(id, productGroupToBeRenamed.newProductGroupName, response);
          })
          .catch((error: any) => {
            this.$store.commit('stopLoading');
            const message: InfoState = { infoType: 'high', infoMsg: (error && error.message) || (this.$t('userGroups.unknowErr').toString()) };
            this.$store.commit('displayMessage', message);
          });
        } else {
          this.renameTenant(id);
        }
        // this.selectedCustomer = [];
        // this.hoveredCustomer = [];
        this.renameCreateCustomer = '';
        const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
        this.$store.commit('displayMessage', message);
      }
    })
    .catch((error: any) => {
      this.$store.commit('stopLoading');
      const message: InfoState = { infoType: 'high', infoMsg: (error && error.message) || (this.$t('userGroups.unknowErr').toString()) };
      this.$store.commit('displayMessage', message);
    });
  }
  renameTenantForLargeCustomer(id : any , name : any, response : any) {
    const newResp = localForageService.renameTenant(response, id, name);
    const newResponse = newResp[0];
    const responseIndex = newResponse.prodGroupLicenseStatus.findIndex((ele : any) => ele.productGroupId === id);
    newResponse.prodGroupLicenseStatus[responseIndex].productGroupName = name;
    const customerListIndex = this.customerList.findIndex((ele : any) => ele.productGroupId === id);
    const tempVar = this.customerList[customerListIndex];
    tempVar.productGroupName = newResponse.prodGroupLicenseStatus[responseIndex].productGroupName;
    this.$set(this.customerList , customerListIndex , tempVar);
    if (this.selectedCustomer.length > 0) {
      this.selectedCustomer = [];
      this.selectedCustomer.push(this.customerList[customerListIndex].productGroupName);
      this.customerListId = this.customerList.findIndex((ele : any) => ele.productGroupName === this.selectedCustomer[0]);
    }
    newResp[0] = newResponse;
    this.saveForageDataForUserGroup(newResp[1], '');
    this.saveForageData(newResp[0], id);
    this.$store.commit('stopLoading');
  }

  renameTenant(id : any) {
    this.$store.commit('startLoading');
    MswApiService.createCustomer.getProductGroupList('createCustomer')
    .then((resp: any) => {
      if (resp.operationStatus === 'OK') {
        const responseIndex = resp.productGroup.findIndex((ele : any) => ele.productGroupId === id);
        const customerListIndex = this.customerList.findIndex((ele : any) => ele.productGroupId === id);
        const tempVar = this.customerList[customerListIndex];
        tempVar.productGroupName = resp.productGroup[responseIndex].productGroupName;
        this.$set(this.customerList , customerListIndex , tempVar);
        if (this.selectedCustomer.length > 0) {
          this.selectedCustomer = [];
          this.selectedCustomer.push(this.customerList[customerListIndex].productGroupName);
          this.customerListId = this.customerList.findIndex((ele : any) => ele.productGroupName === this.selectedCustomer[0]);
        }
      } else {
        const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
        this.$store.commit('displayMessage', message);
      }
    })
    .catch((error: any) => {
      const message: InfoState = { infoType: 'high', infoMsg: (error && error.message) || (this.$t('userGroups.unknowErr').toString()) };
      this.$store.commit('displayMessage', message);
    })
    .finally(() => {
      this.$store.commit('stopLoading');
    });
  }

  deleteProductGroup(id: string) {
    confirmService.confirm({
      status: 'major',
      title: 'Delete tenant group',
      // tslint:disable-next-line:max-line-length
      message: (this.$t('userGroups.ccAndNSMdeleteWarning')
      .toString()),
      buttons: [{ key: 'cancel', name: 'Cancel' }, { key: 'ok', name: 'Confirm', isDefault: true }],
    })
    .then((isConfirmed: any) => {
      if (isConfirmed === 'ok') {
        this.$store.commit('startLoading');
        const productGroupTobeDeleted: any = {
          bsendMail: true,
          productGroupList: [
            {
              productGroupId: id,
            },
          ],
        };
        MswApiService.createCustomer.deleteProductGroup(productGroupTobeDeleted)
        .then((resp: any) => {
          if (resp.operationStatus === 'NOK') {
            const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
            this.$store.commit('displayMessage', message);
          } else {
            this.selectedCustomer = [];
            this.hoveredCustomer = [];
            if (this.$store.getters.isLargeCustomer) {
              this.$store.commit('startLoading');
              this.$store.dispatch('DashBoardStoreModule/populateCustomerWidgets')
              .then((response: any) => {
                this.deleteCustomerForLargeCustomer(response, id);
              });
            } else {
              this.deleteCustomer(id);
            }
            const message :InfoState = { infoType:'success', infoMsg: (this.$t('userGroups.tenantDeleted')
            .toString()) };
            this.$store.commit('displayMessage', message);
          }
        })
        .catch((error: any) => {
          const message: InfoState = { infoType: 'high', infoMsg: (error && error.message) || (this.$t('userGroups.unknowErr').toString()) };
          this.$store.commit('displayMessage', message);
        })
        .finally(() => {
          this.$store.commit('stopLoading');
        });
      }
    });
  }
  deleteCustomerForLargeCustomer(response : any, id : any) {
    const customerListIndex = this.customerList.findIndex((ele : any) => ele.productGroupId === id);
    this.customerList.splice(customerListIndex , 1);
    const tempIndex = this.tempCustomerListVariable.findIndex((ele : any) => ele.productGroupId === id);
    this.tempCustomerListVariable.splice(tempIndex , 1);
    this.productGroupList.splice(tempIndex , 1);
    this.backedUpProductGroup = this.productGroupList;
    this.$set(this.customerList , 0 , this.customerList[0]);
    const responseIndex = response.prodGroupLicenseStatus.findIndex((ele : any) => ele.productGroupId === id);
    response.prodGroupLicenseStatus.splice(responseIndex, 1);
    this.saveForageData(response, id);
    this.newCustomerCount = this.productGroupList.length;
    this.$store.commit('stopLoading');
  }
  deleteCustomer(id : any) {
    this.$store.commit('startLoading');
    MswApiService.createCustomer.getProductGroupList('createCustomer')
    .then((resp: any) => {
      if (resp.operationStatus === 'OK') {
        const responseIndex = resp.productGroup.findIndex((ele : any) => ele.productGroupId === id);
        if (responseIndex === -1) {
          const customerListIndex = this.customerList.findIndex((ele : any) => ele.productGroupId === id);
          this.customerList.splice(customerListIndex , 1);
          const tempIndex = this.tempCustomerListVariable.findIndex((ele : any) => ele.productGroupId === id);
          this.tempCustomerListVariable.splice(tempIndex , 1);
          this.productGroupList.splice(tempIndex , 1);
          this.$set(this.customerList , 0 , this.customerList[0]);
          this.backedUpProductGroup = this.productGroupList;
          this.newCustomerCount = this.productGroupList.length;
        }
      } else {
        const message: InfoState = { infoType: 'high', infoMsg: resp.msgDesc };
        this.$store.commit('displayMessage', message);
      }
    })
    .catch((error: any) => {
      const message: InfoState = { infoType: 'high', infoMsg: (error && error.message) || (this.$t('userGroups.unknowErr').toString()) };
      this.$store.commit('displayMessage', message);
    })
    .finally(() => {
      this.$store.commit('stopLoading');
    });
  }

  editOptClicked(data: any) {
    this.hoveredCustomer[0] = data.list.productGroupName;
    if (data.index === '1') {
      this.editProductGroup(data.list.productGroupName);
    } else if (data.index === '2') {
      this.deleteProductGroup(data.list.productGroupId);
    } else if (data.index === '3') {
      this.mode = 'edit';
      this.tenantDetailResponse = {
        request : {
          productGroup: this.newCustomer,
          partyGroupId: this.defaultGroupId,
          userGrpName: this.productGroupList.partyGroupName,
          source: 'WORKSPACE',
        },
        response : {},
        data : data.list,
      };
      this.showTenantDetail = true;
    } else if (data.index === '4') {
      this.ttDataObj.totalNumOfProd = data.list?.totalProducts || (data.list?.selectedGroup?.length || '0');
      this.ttDataObj.teantName = data.list.productGroupName;
      this.ttDataObj.prodId = data.list.productGroupId;
      this.showTransferTenant = true;
    }
    this.showEditDropDown = false;
  }
  closeTt() {
    this.showTransferTenant = false;
  }
  dropDownVisible(val : any) {
    val ? this.showEditDropDown = false : '';
    this.showEditDropDown = val;
  }
  indexValue(val : any) {
    this.selectedIndex = val;
  }
  tenantCreated(resp : any) {
    this.showMsspButtons = false;
    this.$store.commit('startLoading');
    this.$nextTick(() => {
      this.startTenantIndex = 0;
      this.endTenantIndex = 0;
      this.showMsspButtons = true;
      this.selectedTenantIdForMSSP = '';
      this.showTenantDetail = false;
      if (this.$store.getters.isLargeCustomer) {
        this.$store.dispatch('DashBoardStoreModule/populateCustomerWidgets')
          .then((response: any) => {
            this.addCustomerForLargeCustomer(response, resp.productGroupDetail);
          });
      } else {
        this.newlyCreatedTenantName = this.newCustomer;
        this.loadCustomerList();
      }
      this.enterNewCustomer = false;
      this.selectedCustomer.push(this.newCustomer);
      this.divClicked(true);
      this.newCustomerCount = this.productGroupList.length;
      this.$store.commit('DashBoardStoreModule/updateWidgetInfo', []);
      this.changehelpContent('customer-user-groups-help');
    });
  }
  /** @public imperatively set top/left */
  public updatePosition(pos: number, forVertical: boolean) {
    if (!this.$refs.viewCont) { return; }
    const viewContEl = this.$refs.viewCont as HTMLElement;
    if (forVertical) {
      viewContEl.scrollTop = pos;
    } else {
      viewContEl.scrollLeft = pos;
    }
  }
  getSlicedCustomer() {
    if (this.tempCustomerListVariable) {
      this.customerList = this.tempCustomerListVariable.slice(this.startTenantIndex, this.endTenantIndex);
    } else {
      this.customerList = [];
    }
    if (this.selectedProductGroup !== null) {
      if (this.customerList.findIndex((ele : any) => ele.productGroupName === this.selectedProductGroup.productGroupName) === -1) {
        if (this.upFixClass) {
          this.customerList.unshift(this.selectedProductGroup);
        } else {
          this.customerList.push(this.selectedProductGroup);
        }
      }
      this.customerListId = this.customerList.findIndex((ele: any) => ele.productGroupName === this.selectedCustomer[0]);
    }
    return this.customerList;
  }
  // tslint:disable-next-line:no-unused
  loadCustomerWithoutApi(lastRemenberedName = '', newName = '' , edit = true) {
    this.userGroupCount = this.newUserGroupResponse.length;
    this.tempCustomerListVariable = this.productGroupList.map((ele: any) => {
      const prartyGroupNameList: any = ele.hasOwnProperty('partyGroupName') ? ele.partyGroupName.split('^& ') : [];
      if (edit) {
        if (prartyGroupNameList.includes(lastRemenberedName)) {
          ele.partyGroupName = ele.partyGroupName.replace(lastRemenberedName, newName);
        }
      } else if (lastRemenberedName.length > 0) {
        if (prartyGroupNameList.includes(lastRemenberedName)) {
          // tslint:disable-next-line:prefer-template
          ele.partyGroupName = ele.partyGroupName.replace(lastRemenberedName + ',', newName);
        }
      }
      return this.createAndStoreCustomerObjects(ele);
    });
    this.$set(this.tempCustomerListVariable, 0 , this.tempCustomerListVariable[0]);
    this.updateSelectedProductGroup();
    this.getSlicedCustomer();
    this.$store.commit('stopLoading');
  }
  updateCustomerPartyGroupName(response : any, newName: any , lastRemenberedName: any, edit = true) {
    let productGroupId ;
    response.prodGroupLicenseStatus.forEach((ele : any, index :any) => {
      const prartyGroupNameList: any = ele.hasOwnProperty('partyGroupName') ? ele.partyGroupName.split('^& ') : [];
      if (edit) {
        if (prartyGroupNameList.includes(lastRemenberedName)) {
          productGroupId = ele.productGroupId;
          response.prodGroupLicenseStatus[index].partyGroupName = ele.partyGroupName.replace(lastRemenberedName, newName);
        }
      } else {
        if (prartyGroupNameList.includes(lastRemenberedName)) {
          productGroupId = ele.productGroupId;
          // tslint:disable-next-line:prefer-template
          response.prodGroupLicenseStatus[index].partyGroupName = ele.partyGroupName.replace(lastRemenberedName + ',', newName);
        }
      }
    });
    this.saveForageData(response, productGroupId);
  }
  redirectToMSSP() {
    this.$router.push({ path: `/m/feature/mssp-tenant-mgmt?tenantId=${this.selectedTenantIdForMSSP}` });
  }
  redirectToRegisterProduct() {
    // tslint:disable-next-line:prefer-template
    this.$router.push({ path: `/m/feature/register-products?tenantId=${this.selectedTenantIdForMSSP}` });
  }
  redirectToCancel() {
    this.showMsspButtons = false;
  }
  handleSearchFilter(e : any) {
    this.searchedValue = e;
    if (this.setTimeoutId) {
      clearTimeout(this.setTimeoutId);
      this.setTimeoutId = null;
    }
    this.setTimeoutId = setTimeout(() => {
      if (this.searchedValue.length > 0) {
        this.startTenantIndex = 0;
        if (this.backedUpProductGroup.length > 100) {
          this.endTenantIndex = 100;
        } else {
          this.endTenantIndex = this.backedUpProductGroup.length;
        }
          // this.customerList = [];
        (this.$refs.vscroll as SwScrollView).updatePosition(0, true);
        this.productGroupList = this.productGroupList.filter((each : any) => each.productGroupName.toLowerCase()
          .indexOf(this.searchedValue.toLowerCase()) > -1);
        if (this.productGroupList.length === 0 && this.$store.getters.isLargeCustomer) {
          this.searchTenantInApi();
        } else {
          this.rebuildTempCustomerList();
          this.getSlicedCustomer();
          (this.$refs.vscroll as SwScrollView).updatePosition(0, true);
        }
      } else {
        this.startTenantIndex = 0;
        if (this.backedUpProductGroup.length > 100) {
          this.endTenantIndex = 100;
        } else {
          this.endTenantIndex = this.backedUpProductGroup.length;
        }
        this.productGroupList = this.backedUpProductGroup;
        this.rebuildTempCustomerList();
        this.getSlicedCustomer();
        (this.$refs.vscroll as SwScrollView).updatePosition(0, true);
      }
        // this.awaitingSearch = false;
    },                             500);
    // this.awaitingSearch = true;
  }

  searchTenantInApi() {
    this.$store.commit('startLoading');
    MswApiService.createCustomer.searchTenant(this.searchedValue)
      .then((resp: any) => {
        if (resp.msgCode === 'MSWAPP:SEARCHPRODUCTGROUPSUCCESS') {
          this.productGroupList = resp.productGroup;
          this.rebuildTempCustomerList();
          this.getSlicedCustomer();
          (this.$refs.vscroll as SwScrollView).updatePosition(0, true);
        } else {
          this.customerList = [];
        }
      })
      .catch((error: any) => {
        const message: InfoState = { infoType: 'high', infoMsg: (error && error.message) || (this.$t('userGroups.unknowErr').toString()) };
        this.$store.commit('displayMessage', message);
      })
      .finally(() => {
        this.$store.commit('stopLoading');
      });
  }

  changeExpand() {
    this.isExpandSearchFilter = !this.isExpandSearchFilter;
    if (this.isExpandSearchFilter) {
      this.enterNewCustomer = false;
    }
    // this.isExpandSearchFilter ? this.enterNewCustomer = false : '';
    if (this.isExpandSearchFilter) {
      this.selectCustomer(this.selectedCustomer[0]);
    } else {
      if (this.backedUpProductGroup.length !== this.productGroupList.length) this.handleSearchFilter('');
    }
  }

  closeSearchFilter() {
    if (this.searchedValue === '') {
      if (this.backedUpProductGroup.length !== this.productGroupList.length) this.handleSearchFilter(this.searchedValue);
      this.isExpandSearchFilter = false;
    } else {
      this.searchedValue = '';
      this.handleSearchFilter('');
      this.isExpandSearchFilter = false;
    }
  }
  onSearchBlur() {
    if (this.searchedValue.length === 0) {
      if (this.backedUpProductGroup.length !== this.productGroupList.length) this.handleSearchFilter(this.searchedValue);
      this.isExpandSearchFilter = false;
    }
  }
  // tslint:disable-next-line:variable-name
  saveForageData(newResponse : any , _id: any, stopLoading = false) {
    MswApiService.createCustomer.saveProductsDetailList({}, newResponse)
    .then(() => {
      this.$store.dispatch('DashBoardStoreModule/populateCustomerWidgets')
      .then(() => {
        if (!stopLoading) {
          this.$store.commit('stopLoading');
        }
      });
    });
  }
  // tslint:disable-next-line:variable-name
  saveForageDataForUserGroup(newResponse : any , _id: any, _callDefaultUserGroup = false) {
    MswApiService.createCustomer.saveUserGroupList({}, newResponse)
    .then(() => {
    });
  }
  searchTenants(e : any) {
    this.searchedValue = e;
  }
  loadMoreCustomers(offSet : any) {
    for (let i = this.tempLoadLastIndex; i < offSet ; i += 1) {
      this.tempCustomerListVariable.push(this.createAndStoreCustomerObjects(this.productGroupList[i]));
    }
    this.tempLoadLastIndex = this.tempCustomerListVariable.length;
  }
  refreshCustomerListTillLoaded() {
    for (let i = 0; i < this.tempCustomerListVariable.length ; i += 1) {
      this.tempCustomerListVariable.splice(i, 1, this.createAndStoreCustomerObjects(this.productGroupList[i]));
    }
  }
  refreshCustomerListTillLoadedWithRename() {
    for (let i = 0; i < this.tempCustomerListVariable.length ; i += 1) {
      this.tempCustomerListVariable.splice(i, 1, this.createAndStoreCustomerObjects(this.productGroupList[i]));
    }
    this.$set(this.tempCustomerListVariable, 2 , this.tempCustomerListVariable[2]);
    this.getSlicedCustomer();
  }
  loadUsersForUserGroupForLargeCustomer(selectedUserCopy : any) {
    this.$store.commit('startLoading');
    let tempObj : any = selectedUserCopy;
    let assignedUsers: any = [];
    MswApiService.createCustomer.listUsersForUserGroup(selectedUserCopy.partyGroupId)
      .then((resp: any) => {
        assignedUsers = resp?.content?.assignedusers || [];
        assignedUsers &&
        assignedUsers.length > 0 &&
        assignedUsers.forEach((ele: any, index : any) => {
          const obj : any = {};
          obj['adminPartyId'] = ele.adminPartyId;
          obj['contactId'] = ele.contactId;
          obj['dtLastAccessDate'] = ele.dtLastAccessDate;
          obj['email'] = ele.emailAddress;
          obj['isReadOnlyAccess'] = ele.isReadOnlyAccess;
          obj['lastAccessDate'] = ele.lastAccessDate;
          obj['lastAccessTime'] = ele.lastAccessTime;
          obj['login'] = ele.logon;
          obj['name'] = ele.fullName;
          obj['partyGroupId'] = ele.partyGroupId;
          obj['partyId'] = ele.partyId;
          assignedUsers[index] = obj;
        });
        tempObj = Object.assign(tempObj, {
          usersForUserGroup: assignedUsers.length > 0 ? assignedUsers : [],
          loaded : true,
        });
        return MswApiService.createCustomer.getUserGroup();
      })
      .then((response: any) => {
        const localDataUGIndex = response.userGroups.findIndex((ele: any) => ele.partyGroupId === selectedUserCopy.partyGroupId);
        response.userGroups[localDataUGIndex] = tempObj;
        const changeUgInd = this.newUserGroupResponse.findIndex((ele: any) => ele.partyGroupId === selectedUserCopy.partyGroupId);
        if (changeUgInd > -1) {
          this.$set(this.newUserGroupResponse, changeUgInd, tempObj);
        }
        if (this.customerListId > -1) {
          const obj = this.createAndStoreCustomerObjects(this.customerList[this.customerListId]);
          this.customerList[this.customerListId] = obj;
          this.$set(this.customerList, this.customerListId, this.customerList[this.customerListId]);
        }
        this.saveForageDataForUserGroup(response, '');
        // if (this.selectedUser.hasOwnProperty('permissionsForUserGroup')) {
        this.selectedUser = [tempObj];
        // }
      })
      .catch((error: any) => {
        const message: InfoState = { infoType: 'high', infoMsg: (error && error.message) || (this.$t('userGroups.unknowErr').toString()) };
        this.$store.commit('displayMessage', message);
      })
      .finally(() => {
        this.$store.commit('stopLoading');
      });
  }
  refresh() {
    if (this.$store.getters.isLargeCustomer) {
      this.isHardRefresh =  true;
      this.$store.commit('startLoading');
      Promise.all([
        this.$store.dispatch('DashBoardStoreModule/populateCustomerWidgets', true),
        MswApiService.createCustomer.getUserGroup(true),
      ])
      .then((resp: any) => {
        if (resp[1].hasOwnProperty('userGroups')) {
          this.addUserGroup = resp[1].showCreateUserGrplink.toLowerCase() === 'true';
          if (resp[1].userGroups.length === 0) {
            this.newUserGroupResponse = [];
            this.loadCustomerListOnHardRefresh(resp[0]);
          } else {
            this.loadUGForLargeCustomer(resp[1], resp[0]);
          }
          this.userGroupCount = resp[1].hasOwnProperty('userGroups') ? resp[1].userGroups.length : 0;
        } else {
          this.newUserGroupResponse = [];
          this.loadCustomerListOnHardRefresh(resp[0]);
        }
        this.addUser = resp.showAddProductGrplink.toLowerCase() === 'true';
      });
    }
  }
  loadCustomerListOnHardRefresh(response : any) {
    this.forceFetch = false;
    const resp : any = {};
    resp['showAddProductGrplink'] = response.showAddProductGrplink;
    resp['showCreateProductGrplink'] = response.showCreateProductGrplink;
    resp['showTenantInfo'] = response.showTenantInfo;
    resp['productGroup'] = response.prodGroupLicenseStatus;
    this.then1Execution(resp);
    this.then2Execution();
    this.then3Execution();
  }
}
